// actions.js
import axios from 'axios';
import { buildRentalFilterParams } from './rentalFiltersHelper';
import { parseApiError } from '../../utils/parseApiError';
import { UPLOAD_LIMITS } from '../../constants/propertyUpload';
import { BLOG_LIMITS } from '../../constants/blog';
import {
  FETCH_BLOG_POSTS_REQUEST, FETCH_BLOG_POSTS_SUCCESS, FETCH_BLOG_POSTS_FAIL,
  FETCH_BLOG_FILTERS_REQUEST, FETCH_BLOG_FILTERS_SUCCESS, FETCH_BLOG_FILTERS_FAIL,
  FETCH_BLOG_DETAIL_REQUEST, FETCH_BLOG_DETAIL_SUCCESS, FETCH_BLOG_DETAIL_FAIL,
  CREATE_BLOG_POST_REQUEST, CREATE_BLOG_POST_SUCCESS, CREATE_BLOG_POST_FAIL,
  UPDATE_BLOG_POST_REQUEST, UPDATE_BLOG_POST_SUCCESS, UPDATE_BLOG_POST_FAIL,
  DELETE_BLOG_POST_REQUEST, DELETE_BLOG_POST_SUCCESS, DELETE_BLOG_POST_FAIL,
  CLEAR_BLOG_DETAIL,
} from './actionTypes';
import { 
  LOGIN_SUCCESS, 
  LOGIN_FAIL, 
  GET_USER_SUCCESS, 
  GET_USER_FAIL, 
  GET_ALL_USERS_SUCCESS, 
  GET_ALL_USERS_FAIL, 
  UPDATE_MAP_LOCATION,
  GET_PROPERTIES_BY_SELLER_ID_SUCCESS,
  GET_PROPERTIES_BY_SELLER_ID_FAIL,
  EDIT_PROPERTY_REQUEST,
  EDIT_PROPERTY_SUCCESS,
  EDIT_PROPERTY_FAIL,
  GET_PROPERTY_BY_ID,
  GET_PROPERTIES_PENDING_SUCCESS,
  GET_PROPERTIES_PENDING_FAIL,
  GET_PROPERTIES_LIST_SUCCESS,
  GET_PROPERTIES_LIST_FAIL,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  GET_ALL_SELLERS_SUCCESS,
  GET_ALL_SELLERS_FAIL,
  UPDATE_SELLER_SUCCESS,
  UPDATE_SELLER_FAIL,
  UPDATE_SELLER_REQUEST,
  CREATE_VISITA_REQUEST,
  CREATE_VISITA_SUCCESS,
  CREATE_VISITA_FAIL,
  GET_ALL_VISITAS_REQUEST,
  GET_ALL_VISITAS_SUCCESS,
  GET_ALL_VISITAS_FAIL,
  GET_VISITAS_BY_PROPERTY_REQUEST,
  GET_VISITAS_BY_PROPERTY_SUCCESS,
  GET_VISITAS_BY_PROPERTY_FAIL,
  GET_PROPERTIES_BY_SELLER,
  GET_PROPERTIES_BY_SELLER_ERROR,
  GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS,
  GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL,
  FETCH_RENTALS_REQUEST,
  FETCH_RENTALS_SUCCESS,
  FETCH_RENTALS_FAILURE,
  FETCH_RENTAL_REQUEST,
  FETCH_RENTAL_SUCCESS,
  FETCH_RENTAL_FAILURE,
  CREATE_RENTAL_REQUEST,
  CREATE_RENTAL_SUCCESS,
  CREATE_RENTAL_FAILURE,
  UPDATE_RENTAL_REQUEST,
  UPDATE_RENTAL_SUCCESS,
  UPDATE_RENTAL_FAILURE,
  DELETE_RENTAL_REQUEST,
  DELETE_RENTAL_SUCCESS,
  DELETE_RENTAL_FAILURE,
  CANCEL_RENTAL_REQUEST,
  CANCEL_RENTAL_SUCCESS,
  CANCEL_RENTAL_FAILURE,
  REACTIVATE_RENTAL_REQUEST,
  REACTIVATE_RENTAL_SUCCESS,
  REACTIVATE_RENTAL_FAILURE,
  GET_CLOSED_PROPERTIES_REQUEST,
  GET_CLOSED_PROPERTIES_SUCCESS,
  GET_CLOSED_PROPERTIES_FAIL,         
  SESSION_STARTED,
  SESSION_ENDED,
  SESSION_HISTORY_SUCCESS,
  SESSION_HISTORY_FAIL,
  SESSION_MONTHLY_SUCCESS,
  SESSION_MONTHLY_FAIL,
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_SUCCESS, 
  FETCH_EVENTS_FAIL,
  CREATE_EVENT_REQUEST, 
  CREATE_EVENT_SUCCESS, 
  CREATE_EVENT_FAIL,
  UPDATE_EVENT_REQUEST, 
  UPDATE_EVENT_SUCCESS, 
  UPDATE_EVENT_FAIL,
  DELETE_EVENT_REQUEST, 
  DELETE_EVENT_SUCCESS, 
  DELETE_EVENT_FAIL,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAIL,
  GET_CLIENTS_BY_SELLER_REQUEST,
  GET_CLIENTS_BY_SELLER_SUCCESS,
  GET_CLIENTS_BY_SELLER_FAIL,
  GET_ALL_CLIENTS_REQUEST,
  GET_ALL_CLIENTS_SUCCESS,
  GET_ALL_CLIENTS_FAIL,
  GET_CLIENT_BY_ID_REQUEST,
  GET_CLIENT_BY_ID_SUCCESS,
  GET_CLIENT_BY_ID_FAIL,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
  ASSOCIATE_CLIENT_PROPERTY_REQUEST,
  ASSOCIATE_CLIENT_PROPERTY_SUCCESS,
  ASSOCIATE_CLIENT_PROPERTY_FAIL,
  GET_CLIENTS_BY_PROPERTY_REQUEST,
  GET_CLIENTS_BY_PROPERTY_SUCCESS,
  GET_CLIENTS_BY_PROPERTY_FAIL,
  // Rental Management action types
  FETCH_RENTAL_DASHBOARD_REQUEST,
  FETCH_RENTAL_DASHBOARD_SUCCESS,
  FETCH_RENTAL_DASHBOARD_FAIL,
  FETCH_RENTAL_OVERVIEW_REQUEST,
  FETCH_RENTAL_OVERVIEW_SUCCESS,
  FETCH_RENTAL_OVERVIEW_FAIL,
  FETCH_ACTIVE_RENTALS_REQUEST,
  FETCH_ACTIVE_RENTALS_SUCCESS,
  FETCH_ACTIVE_RENTALS_FAIL,
  FETCH_RENTAL_DETAIL_REQUEST,
  FETCH_RENTAL_DETAIL_SUCCESS,
  FETCH_RENTAL_DETAIL_FAIL,
  FETCH_OVERDUE_PAYMENTS_REQUEST,
  FETCH_OVERDUE_PAYMENTS_SUCCESS,
  FETCH_OVERDUE_PAYMENTS_FAIL,
  FETCH_EXPIRING_CONTRACTS_REQUEST,
  FETCH_EXPIRING_CONTRACTS_SUCCESS,
  FETCH_EXPIRING_CONTRACTS_FAIL,
  GENERATE_PAYMENT_SCHEDULE_REQUEST,
  GENERATE_PAYMENT_SCHEDULE_SUCCESS,
  GENERATE_PAYMENT_SCHEDULE_FAIL,
  FETCH_RENTAL_PAYMENTS_REQUEST,
  FETCH_RENTAL_PAYMENTS_SUCCESS,
  FETCH_RENTAL_PAYMENTS_FAIL,
  REGISTER_PAYMENT_REQUEST,
  REGISTER_PAYMENT_SUCCESS,
  REGISTER_PAYMENT_FAIL,
  UPDATE_OVERDUE_PAYMENTS_REQUEST,
  UPDATE_OVERDUE_PAYMENTS_SUCCESS,
  UPDATE_OVERDUE_PAYMENTS_FAIL,
  CREATE_RENTAL_ADJUSTMENT_REQUEST,
  CREATE_RENTAL_ADJUSTMENT_SUCCESS,
  CREATE_RENTAL_ADJUSTMENT_FAIL,
  SIMULATE_RENTAL_ADJUSTMENT_REQUEST,
  SIMULATE_RENTAL_ADJUSTMENT_SUCCESS,
  SIMULATE_RENTAL_ADJUSTMENT_FAIL,
  FETCH_ADJUSTMENT_HISTORY_REQUEST,
  FETCH_ADJUSTMENT_HISTORY_SUCCESS,
  FETCH_ADJUSTMENT_HISTORY_FAIL,
  FETCH_UPCOMING_ADJUSTMENTS_REQUEST,
  FETCH_UPCOMING_ADJUSTMENTS_SUCCESS,
  FETCH_UPCOMING_ADJUSTMENTS_FAIL,
  NOTIFY_ADJUSTMENT_REQUEST,
  NOTIFY_ADJUSTMENT_SUCCESS,
  NOTIFY_ADJUSTMENT_FAIL,
  CREATE_RENTAL_TENANT_REQUEST,
  CREATE_RENTAL_TENANT_SUCCESS,
  CREATE_RENTAL_TENANT_FAIL,
  FETCH_RENTAL_TENANTS_REQUEST,
  FETCH_RENTAL_TENANTS_SUCCESS,
  FETCH_RENTAL_TENANTS_FAIL,
  UPDATE_RENTAL_TENANT_REQUEST,
  UPDATE_RENTAL_TENANT_SUCCESS,
  UPDATE_RENTAL_TENANT_FAIL,
  DELETE_RENTAL_TENANT_REQUEST,
  DELETE_RENTAL_TENANT_SUCCESS,
  DELETE_RENTAL_TENANT_FAIL,
  CLEAR_RENTAL_STATE,
  SET_RENTAL_LOADING,
  FETCH_VISITAS_STATS_REQUEST,
  FETCH_VISITAS_STATS_SUCCESS,
  FETCH_VISITAS_STATS_FAIL,
  FETCH_VISITAS_STATS_PERIOD_REQUEST,
  FETCH_VISITAS_STATS_PERIOD_SUCCESS,
  FETCH_VISITAS_STATS_PERIOD_FAIL,
  FETCH_SELLERS_STATS_REQUEST,
  FETCH_SELLERS_STATS_SUCCESS,
  FETCH_SELLERS_STATS_FAIL,
  FETCH_REUNIONES_RANKING_REQUEST,
  FETCH_REUNIONES_RANKING_SUCCESS,
  FETCH_REUNIONES_RANKING_FAIL,
  FETCH_REUNIONES_INFORME_REQUEST,
  FETCH_REUNIONES_INFORME_SUCCESS,
  FETCH_REUNIONES_INFORME_FAIL,
  FETCH_REUNIONES_TIPS_REQUEST,
  FETCH_REUNIONES_TIPS_SUCCESS,
  FETCH_REUNIONES_TIPS_FAIL,
  CREATE_REUNION_REQUEST,
  CREATE_REUNION_SUCCESS,
  CREATE_REUNION_FAIL,
  UPDATE_REUNION_REQUEST,
  UPDATE_REUNION_SUCCESS,
  UPDATE_REUNION_FAIL,
  DELETE_REUNION_REQUEST,
  DELETE_REUNION_SUCCESS,
  DELETE_REUNION_FAIL,
  FETCH_REUNIONES_LIST_REQUEST,
  FETCH_REUNIONES_LIST_SUCCESS,
  FETCH_REUNIONES_LIST_FAIL,
  FETCH_ACTIVE_SELLERS_REQUEST,
  FETCH_ACTIVE_SELLERS_SUCCESS,
  FETCH_ACTIVE_SELLERS_FAIL,
  FETCH_REUNIONES_DASHBOARD_REQUEST,
  FETCH_REUNIONES_DASHBOARD_SUCCESS,
  FETCH_REUNIONES_DASHBOARD_FAIL,
  FETCH_REUNIONES_COMPARATIVA_REQUEST,
  FETCH_REUNIONES_COMPARATIVA_SUCCESS,
  FETCH_REUNIONES_COMPARATIVA_FAIL,
  FETCH_REUNIONES_ANUAL_REQUEST,
  FETCH_REUNIONES_ANUAL_SUCCESS,
  FETCH_REUNIONES_ANUAL_FAIL,
  FETCH_VISITAS_AGENT_STATS_REQUEST,
  FETCH_VISITAS_AGENT_STATS_SUCCESS,
  FETCH_VISITAS_AGENT_STATS_FAIL,
  CLEAR_ESTADISTICAS_STATE,
  CREATE_VISITA_EXTERNA_REQUEST,
  CREATE_VISITA_EXTERNA_SUCCESS,
  CREATE_VISITA_EXTERNA_FAIL,
  GET_VISITAS_EXTERNAS_REQUEST,
  GET_VISITAS_EXTERNAS_SUCCESS,
  GET_VISITAS_EXTERNAS_FAIL,
  GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST,
  GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS,
  GET_VISITAS_EXTERNAS_BY_AGENT_FAIL,
  UPDATE_VISITA_EXTERNA_REQUEST,
  UPDATE_VISITA_EXTERNA_SUCCESS,
  UPDATE_VISITA_EXTERNA_FAIL,
  DELETE_VISITA_EXTERNA_REQUEST,
  DELETE_VISITA_EXTERNA_SUCCESS,
  DELETE_VISITA_EXTERNA_FAIL,
  CREATE_OPERACION_EXTERNA_REQUEST,
  CREATE_OPERACION_EXTERNA_SUCCESS,
  CREATE_OPERACION_EXTERNA_FAIL,
  GET_OPERACIONES_EXTERNAS_REQUEST,
  GET_OPERACIONES_EXTERNAS_SUCCESS,
  GET_OPERACIONES_EXTERNAS_FAIL,
  GET_OPERACION_EXTERNA_BY_ID_REQUEST,
  GET_OPERACION_EXTERNA_BY_ID_SUCCESS,
  GET_OPERACION_EXTERNA_BY_ID_FAIL,
  UPDATE_OPERACION_EXTERNA_REQUEST,
  UPDATE_OPERACION_EXTERNA_SUCCESS,
  UPDATE_OPERACION_EXTERNA_FAIL,
  DELETE_OPERACION_EXTERNA_REQUEST,
  DELETE_OPERACION_EXTERNA_SUCCESS,
  DELETE_OPERACION_EXTERNA_FAIL,
  FETCH_UPCOMING_EVENTS_REQUEST,
  FETCH_UPCOMING_EVENTS_SUCCESS,
  FETCH_UPCOMING_EVENTS_FAIL,
  FETCH_EVENT_BY_ID_REQUEST,
  FETCH_EVENT_BY_ID_SUCCESS,
  FETCH_EVENT_BY_ID_FAIL,
  MARK_EVENT_SEEN_REQUEST,
  MARK_EVENT_SEEN_SUCCESS,
  MARK_EVENT_SEEN_FAIL,
  CHANGE_EVENT_STATUS_REQUEST,
  CHANGE_EVENT_STATUS_SUCCESS,
  CHANGE_EVENT_STATUS_FAIL,
  // Property Versioning & Approval
  FETCH_PROPERTY_VERSIONS_REQUEST,
  FETCH_PROPERTY_VERSIONS_SUCCESS,
  FETCH_PROPERTY_VERSIONS_FAIL,
  REVERT_PROPERTY_VERSION_REQUEST,
  REVERT_PROPERTY_VERSION_SUCCESS,
  REVERT_PROPERTY_VERSION_FAIL,
  FETCH_PROPERTY_COMMENTS_REQUEST,
  FETCH_PROPERTY_COMMENTS_SUCCESS,
  FETCH_PROPERTY_COMMENTS_FAIL,
  ADD_PROPERTY_COMMENT_REQUEST,
  ADD_PROPERTY_COMMENT_SUCCESS,
  ADD_PROPERTY_COMMENT_FAIL,
  MARK_COMMENT_READ_SUCCESS,
  MARK_COMMENT_READ_FAIL,
  APPROVE_PROPERTY_REQUEST,
  APPROVE_PROPERTY_SUCCESS,
  APPROVE_PROPERTY_FAIL,
  REJECT_PROPERTY_REQUEST,
  REJECT_PROPERTY_SUCCESS,
  REJECT_PROPERTY_FAIL,
  REQUEST_REVISION_REQUEST,
  REQUEST_REVISION_SUCCESS,
  REQUEST_REVISION_FAIL,
  APPROVE_DOCUMENTATION_REQUEST,
  APPROVE_DOCUMENTATION_SUCCESS,
  APPROVE_DOCUMENTATION_FAIL,
  REJECT_DOCUMENTATION_REQUEST,
  REJECT_DOCUMENTATION_SUCCESS,
  REJECT_DOCUMENTATION_FAIL,
  FETCH_DOCUMENTATION_STATUS_REQUEST,
  FETCH_DOCUMENTATION_STATUS_SUCCESS,
  FETCH_DOCUMENTATION_STATUS_FAIL,
  FETCH_REVIEW_PROPERTIES_REQUEST,
  FETCH_REVIEW_PROPERTIES_SUCCESS,
  FETCH_REVIEW_PROPERTIES_FAIL,
  // VRC
  CREATE_VRC_REQUEST, CREATE_VRC_SUCCESS, CREATE_VRC_FAIL,
  FETCH_VRCS_REQUEST, FETCH_VRCS_SUCCESS, FETCH_VRCS_FAIL,
  FETCH_VRC_BY_ID_REQUEST, FETCH_VRC_BY_ID_SUCCESS, FETCH_VRC_BY_ID_FAIL,
  UPDATE_VRC_REQUEST, UPDATE_VRC_SUCCESS, UPDATE_VRC_FAIL,
  DELETE_VRC_REQUEST, DELETE_VRC_SUCCESS, DELETE_VRC_FAIL,
  FETCH_VRC_VERSIONS_REQUEST, FETCH_VRC_VERSIONS_SUCCESS, FETCH_VRC_VERSIONS_FAIL,
  REVERT_VRC_VERSION_REQUEST, REVERT_VRC_VERSION_SUCCESS, REVERT_VRC_VERSION_FAIL,
  FETCH_VRC_BY_CODE_REQUEST, FETCH_VRC_BY_CODE_SUCCESS, FETCH_VRC_BY_CODE_FAIL,
  DUPLICATE_VRC_REQUEST, DUPLICATE_VRC_SUCCESS, DUPLICATE_VRC_FAIL,
  FETCH_VRC_STATS_REQUEST, FETCH_VRC_STATS_SUCCESS, FETCH_VRC_STATS_FAIL,
  CLEAR_VRC_DETAIL,
  // Admin Rentals (Solo Administración)
  FETCH_ADMIN_RENTAL_DASHBOARD_REQUEST, FETCH_ADMIN_RENTAL_DASHBOARD_SUCCESS, FETCH_ADMIN_RENTAL_DASHBOARD_FAIL,
  FETCH_ACTIVE_ADMIN_RENTALS_REQUEST, FETCH_ACTIVE_ADMIN_RENTALS_SUCCESS, FETCH_ACTIVE_ADMIN_RENTALS_FAIL,
  FETCH_ADMIN_RENTAL_LIST_REQUEST, FETCH_ADMIN_RENTAL_LIST_SUCCESS, FETCH_ADMIN_RENTAL_LIST_FAIL,
  FETCH_ADMIN_RENTAL_DETAIL_REQUEST, FETCH_ADMIN_RENTAL_DETAIL_SUCCESS, FETCH_ADMIN_RENTAL_DETAIL_FAIL,
  FETCH_EXPIRING_ADMIN_RENTALS_REQUEST, FETCH_EXPIRING_ADMIN_RENTALS_SUCCESS, FETCH_EXPIRING_ADMIN_RENTALS_FAIL,
  FETCH_OVERDUE_ADMIN_PAYMENTS_REQUEST, FETCH_OVERDUE_ADMIN_PAYMENTS_SUCCESS, FETCH_OVERDUE_ADMIN_PAYMENTS_FAIL,
  FETCH_ADMIN_CONTRACT_SUMMARY_REQUEST, FETCH_ADMIN_CONTRACT_SUMMARY_SUCCESS, FETCH_ADMIN_CONTRACT_SUMMARY_FAIL,
  CREATE_ADMIN_RENTAL_REQUEST, CREATE_ADMIN_RENTAL_SUCCESS, CREATE_ADMIN_RENTAL_FAIL,
  UPDATE_ADMIN_RENTAL_REQUEST, UPDATE_ADMIN_RENTAL_SUCCESS, UPDATE_ADMIN_RENTAL_FAIL,
  DELETE_ADMIN_RENTAL_REQUEST, DELETE_ADMIN_RENTAL_SUCCESS, DELETE_ADMIN_RENTAL_FAIL,
  CANCEL_ADMIN_RENTAL_REQUEST, CANCEL_ADMIN_RENTAL_SUCCESS, CANCEL_ADMIN_RENTAL_FAIL,
  REACTIVATE_ADMIN_RENTAL_REQUEST, REACTIVATE_ADMIN_RENTAL_SUCCESS, REACTIVATE_ADMIN_RENTAL_FAIL,
  GENERATE_ADMIN_PAYMENT_SCHEDULE_REQUEST, GENERATE_ADMIN_PAYMENT_SCHEDULE_SUCCESS, GENERATE_ADMIN_PAYMENT_SCHEDULE_FAIL,
  FETCH_ADMIN_RENTAL_PAYMENTS_REQUEST, FETCH_ADMIN_RENTAL_PAYMENTS_SUCCESS, FETCH_ADMIN_RENTAL_PAYMENTS_FAIL,
  REGISTER_ADMIN_RENTAL_PAYMENT_REQUEST, REGISTER_ADMIN_RENTAL_PAYMENT_SUCCESS, REGISTER_ADMIN_RENTAL_PAYMENT_FAIL,
  FETCH_UPCOMING_ADMIN_PAYMENTS_REQUEST, FETCH_UPCOMING_ADMIN_PAYMENTS_SUCCESS, FETCH_UPCOMING_ADMIN_PAYMENTS_FAIL,
  UPDATE_OVERDUE_ADMIN_PAYMENTS_REQUEST, UPDATE_OVERDUE_ADMIN_PAYMENTS_SUCCESS, UPDATE_OVERDUE_ADMIN_PAYMENTS_FAIL,
  CREATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST, CREATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS, CREATE_ADMIN_RENTAL_ADJUSTMENT_FAIL,
  SIMULATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST, SIMULATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS, SIMULATE_ADMIN_RENTAL_ADJUSTMENT_FAIL,
  FETCH_ADMIN_ADJUSTMENT_HISTORY_REQUEST, FETCH_ADMIN_ADJUSTMENT_HISTORY_SUCCESS, FETCH_ADMIN_ADJUSTMENT_HISTORY_FAIL,
  FETCH_UPCOMING_ADMIN_ADJUSTMENTS_REQUEST, FETCH_UPCOMING_ADMIN_ADJUSTMENTS_SUCCESS, FETCH_UPCOMING_ADMIN_ADJUSTMENTS_FAIL,
  NOTIFY_ADMIN_ADJUSTMENT_REQUEST, NOTIFY_ADMIN_ADJUSTMENT_SUCCESS, NOTIFY_ADMIN_ADJUSTMENT_FAIL,
  CREATE_ADMIN_RENTAL_TENANT_REQUEST, CREATE_ADMIN_RENTAL_TENANT_SUCCESS, CREATE_ADMIN_RENTAL_TENANT_FAIL,
  FETCH_ADMIN_RENTAL_TENANTS_REQUEST, FETCH_ADMIN_RENTAL_TENANTS_SUCCESS, FETCH_ADMIN_RENTAL_TENANTS_FAIL,
  UPDATE_ADMIN_RENTAL_TENANT_REQUEST, UPDATE_ADMIN_RENTAL_TENANT_SUCCESS, UPDATE_ADMIN_RENTAL_TENANT_FAIL,
  DELETE_ADMIN_RENTAL_TENANT_REQUEST, DELETE_ADMIN_RENTAL_TENANT_SUCCESS, DELETE_ADMIN_RENTAL_TENANT_FAIL,
  CLEAR_ADMIN_RENTAL_STATE,
  FETCH_RENTAL_AUDIT_LOG_REQUEST, FETCH_RENTAL_AUDIT_LOG_SUCCESS, FETCH_RENTAL_AUDIT_LOG_FAIL,
  FETCH_OPERATIONS_HISTORY_REQUEST, FETCH_OPERATIONS_HISTORY_SUCCESS, FETCH_OPERATIONS_HISTORY_FAIL,
  FETCH_CONTRACTS_COVERAGE_REQUEST, FETCH_CONTRACTS_COVERAGE_SUCCESS, FETCH_CONTRACTS_COVERAGE_FAIL,
  FETCH_RENEWALS_REPORT_REQUEST, FETCH_RENEWALS_REPORT_SUCCESS, FETCH_RENEWALS_REPORT_FAIL,
  RENEW_RENTAL_REQUEST, RENEW_RENTAL_SUCCESS, RENEW_RENTAL_FAIL

 } from './actionTypes';

export const login = ({ mail, password }) => async dispatch => {
  try {
    const response = await axios.post('/login', { mail, password });
    const user = response.data.user;
    if (!user || !user.id) {
      throw new Error('ID de usuario no válido en la respuesta');
    }
    const userId = user.id;
    const userType = user.type;

    // Iniciar sesión en el backend de sesiones
    const sessionRes = await axios.post('/session-start', { userId });
    const sessionId = sessionRes.data.sessionId;

    dispatch({
      type: LOGIN_SUCCESS,
      payload: {
        user: user,
        userId: userId,
        userType: userType,
        sessionId: sessionId, // Puedes guardar el sessionId en el estado si lo necesitas
      }
    });

    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('userId', userId);
    localStorage.setItem('userType', userType);
    localStorage.setItem('sessionId', sessionId); // Guarda el sessionId para usarlo al cerrar sesión

    dispatch(getUser(userId));
    return true;
  } catch (error) {
    console.error('Error de inicio de sesión:', error);
    dispatch({
      type: LOGIN_FAIL,
      payload: 'Credenciales inválidas'
    });
    return false;
  }
};

// Puedes agregar esto en actions.js si no tienes una action de logout centralizada
export const logout = () => async dispatch => {
  try {
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      await dispatch(endSession(sessionId, false)); // false si no es por inactividad
      localStorage.removeItem('sessionId');
    }
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    localStorage.removeItem('userType');
    dispatch({ type: LOGIN_FAIL }); // Limpia el usuario en redux
    window.location.href = '/'; // Redirige al login
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
  }
};

// Iniciar sesión (crear sesión)
export const startSession = (userId) => async dispatch => {
  const res = await axios.post('/session-start', { userId });
  dispatch({ type: SESSION_STARTED, payload: res.data.sessionId });
};

// Finalizar sesión (cerrar sesión)
export const endSession = (sessionId, idleLogout = false) => async dispatch => {
  await axios.post('/session-end', { sessionId, idleLogout });
  dispatch({ type: SESSION_ENDED });
};

// Obtener historial de sesiones de un usuario
export const fetchSessionHistory = (userId) => async dispatch => {
  try {
    const res = await axios.get(`/session-history?userId=${userId}`);
    dispatch({ type: SESSION_HISTORY_SUCCESS, payload: { userId, history: res.data } });
  } catch (error) {
    dispatch({ type: SESSION_HISTORY_FAIL, payload: error.message });
  }
};

// Obtener estadísticas mensuales de un usuario
export const fetchSessionMonthly = (userId, month) => async dispatch => {
  try {
    const res = await axios.get(`/session-monthly?userId=${userId}&month=${month}`);
    dispatch({ type: SESSION_MONTHLY_SUCCESS, payload: { userId, stats: res.data } });
  } catch (error) {
    dispatch({ type: SESSION_MONTHLY_FAIL, payload: error.message });
  }
};

export const getUser = userId => async dispatch => {
  try {
    // console.log('ID del usuario antes de obtener los detalles:', userId);
    if (!userId) {
      throw new Error('El ID del usuario no está definido');
    }
    
    const response = await axios.get(`/seller/${userId}`);
    // console.log('Detalles del usuario obtenidos del backend:', response.data);
    dispatch({
      type: GET_USER_SUCCESS,
      payload: response.data // Ajustar la respuesta según tu backend
    });
  } catch (error) {
    console.error('Error al obtener los detalles del usuario:', error);
    dispatch({
      type: GET_USER_FAIL,
      payload: 'Error al obtener los detalles del usuario' // Otra posibilidad: error.response.data.message
    });
  }
};

export const createProperty = (formData, options = {}) => async (dispatch) => {
  const { onUploadProgress, signal } = options;
  try {
      dispatch({ type: 'CREATE_PROPERTY_REQUEST' });

      const config = {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
          // 2 min: coincide con el timeout del backend en cargas pesadas
          timeout: UPLOAD_LIMITS.REQUEST_TIMEOUT_MS,
          signal,
          onUploadProgress,
      };

      // URL relativa: respeta axios.defaults.baseURL (prod/local según index.js)
      const { data, headers } = await axios.post('/property', formData, config);

      const requestId = data?.requestId || headers?.['x-request-id'] || null;

      dispatch({
          type: 'CREATE_PROPERTY_SUCCESS',
          payload: data,
      });

      return { success: true, data, requestId };
  } catch (error) {
      // Normaliza cualquier error (red, timeout, abort o envelope del backend)
      const normalized = parseApiError(error);
      dispatch({
          type: 'CREATE_PROPERTY_FAIL',
          payload: normalized.userMessage,
      });

      return {
        success: false,
        message: normalized.userMessage,
        type: normalized.type,
        status: normalized.status,
        requestId: normalized.requestId,
        fieldErrors: normalized.fieldErrors,
        errors: normalized.errors,
        retriable: normalized.retriable,
      };
  }
};

export const getAllUsers = () => async (dispatch) => {
  try {
    const response = await axios.get('/users');
    dispatch({
      type: GET_ALL_USERS_SUCCESS,
      payload: response.data.data,
    });
    return response.data.data;
  } catch (error) {
    console.error('Error al obtener los usuarios:', error);
    dispatch({
      type:  GET_ALL_USERS_FAIL,
      payload: 'Error al obtener los usuarios',
    });
    return null;
  }
};

export const updateMapLocation = (location) => ({
  type: UPDATE_MAP_LOCATION,
  payload: location,
});


// Acción para obtener las propiedades relacionadas al vendedor por su id
export const getPropertiesBySellerId = (userId) => async (dispatch) => {
  if (!userId) {
    dispatch({
      type: GET_PROPERTIES_BY_SELLER_ID_FAIL,
      payload: 'El ID del usuario no está definido',
    });
    return; // Salir de la función si no hay userId
  }

  const userType = localStorage.getItem('userType'); // Recuperar el tipo de usuario desde localStorage

  try {
    let response;
    if (userType === 'MARTILLER') {
      response = await axios.get(`/properties/martiller/${userId}`);
    } else if (userType === 'Vendedor') {
      response = await axios.get(`/properties/seller/${userId}`);
    } else {
      throw new Error('Tipo de usuario desconocido');
    }

    dispatch({
      type: GET_PROPERTIES_BY_SELLER_ID_SUCCESS,
      payload: response.data.data,
    });
    // console.log('Propiedades obtenidas:', response.data.data);
  } catch (error) {
    console.error('Error al obtener las propiedades del vendedor:', error);
    dispatch({
      type: GET_PROPERTIES_BY_SELLER_ID_FAIL,
      payload: 'Error al obtener las propiedades del vendedor',
    });
  }
};


// Acción para obtener las propiedades CERRADAS relacionadas al vendedor por su id
export const getPropertiesClosedBySellerId = (userId) => async (dispatch) => {
  if (!userId) {
    dispatch({
      type: GET_PROPERTIES_BY_SELLER_ID_FAIL,
      payload: 'El ID del usuario no está definido',
    });
    return; // Salir de la función si no hay userId
  }

  const userType = localStorage.getItem('userType'); // Recuperar el tipo de usuario desde localStorage

  try {
    let response;
    if (userType === 'MARTILLER') {
      response = await axios.get(`/properties/martiller/closed/${userId}`);
    } else if (userType === 'Vendedor') {
      response = await axios.get(`/properties/closed/${userId}`);
    } else {
      throw new Error('Tipo de usuario desconocido');
    }
console.log(response);

    dispatch({
      type: GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS,
      payload: response.data.data,
    });
    // console.log('Propiedades obtenidas:', response.data.data);
  } catch (error) {
    console.error('Error al obtener las propiedades del vendedor:', error);
    dispatch({
      type: GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL,
      payload: 'Error al obtener las propiedades del vendedor',
    });
  }
};





export const editProperty = (propertyId, propertyData) => async (dispatch) => {
  try {
    dispatch({ type: EDIT_PROPERTY_REQUEST });

    const response = await axios.put(`/properties/${propertyId}`, propertyData);
    dispatch({ type: EDIT_PROPERTY_SUCCESS, payload: response.data });

    return response.data;
  } catch (error) {
    console.error('Error al editar la propiedad:', error);
    dispatch({ type: EDIT_PROPERTY_FAIL, payload: 'Error al editar la propiedad' });
    throw error;
  }
};


export const getPropertyById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/property/${id}`);
    dispatch({
      type: GET_PROPERTY_BY_ID,
      payload: res.data,
    });
  } catch (err) {
    console.error(err);
    // Handle error accordingly
  }
};

export const getPendingProperties = () => async (dispatch) => {
  try {
    const response = await axios.get('/properties/pending');
    console.log(response);
    dispatch({
      type: GET_PROPERTIES_PENDING_SUCCESS,
      payload: response.data.data, // Ajustar según la estructura de la respuesta
    });
  } catch (error) {
    console.error('Error al obtener propiedades pendientes:', error);
    dispatch({
      type: GET_PROPERTIES_PENDING_FAIL,
      payload: 'Error al obtener propiedades pendientes',
    });
  }
};

export const getListProperties = (endpoint) => async (dispatch) => {
  try {
    const response = await axios.get(endpoint); // Usar el endpoint dinámico
    console.log(response);
    dispatch({
      type: GET_PROPERTIES_LIST_SUCCESS,
      payload: response.data.properties, // Ajustar según la estructura de la respuesta
    });
  } catch (error) {
    console.error('Error al obtener propiedades activas:', error);
    dispatch({
      type: GET_PROPERTIES_LIST_FAIL,
      payload: 'Error al obtener propiedades activas',
    });
  }
};

export const createUserSeller = (userData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_USER_REQUEST });

    // Llamada a la API para crear el usuario
    const response = await axios.post('/seller', userData);

    dispatch({
      type: CREATE_USER_SUCCESS,
      payload: response.data,
    });

    alert('Usuario creado con éxito');
    // Redireccionar o realizar alguna acción adicional si es necesario
    window.location.href = '/home';
  } catch (error) {
    const backendMsg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      (typeof error?.response?.data === 'string' ? error.response.data : null) ||
      error.message ||
      'Error al crear el usuario';

    dispatch({
      type: CREATE_USER_FAIL,
      payload: backendMsg,
    });

    console.error('Error al crear usuario:', error?.response?.status, error?.response?.data || error);
    alert(`Error al crear el usuario: ${backendMsg}`);
  }
};

// Action para obtener todos los vendedores
// Action para obtener todos los vendedores
export const getAllSellers = (status) => async (dispatch) => {
  try {
    // Construye la URL con el query param 'status' si se proporciona
    const query = status ? `?status=${status}` : '';
    const response = await axios.get(`/sellers${query}`);

    // El backend puede devolver el array crudo o envuelto en { data: [...] }.
    // Normalizamos a array para que los consumidores (CardSellersContainer,
    // CalendarView, etc.) no tengan que parchar cada uno.
    const raw = response.data;
    const list = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);

    dispatch({
      type: GET_ALL_SELLERS_SUCCESS,
      payload: list,
    });
  } catch (error) {
    console.error('Error al obtener los vendedores:', error);
    dispatch({
      type: GET_ALL_SELLERS_FAIL,
      payload: error.message || 'Error al obtener los vendedores'
    });
  }
};
// Acción para actualizar un vendedor
export const updateSeller = (id, sellerData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_SELLER_REQUEST });

    const response = await axios.put(`/sellers/${id}`, sellerData);
    dispatch({
      type: UPDATE_SELLER_SUCCESS,
      payload: response.data // Asume que el servidor devuelve el vendedor actualizado
    });

    alert('Vendedor actualizado con éxito');
    // Puedes redirigir o actualizar la UI según sea necesario
  } catch (error) {
    console.error('Error al actualizar el vendedor:', error);
    alert('Error al actualizar el vendedor. Por favor, revise los datos e intente nuevamente.');
    dispatch({
      type: UPDATE_SELLER_FAIL,
      payload: 'Error al actualizar el vendedor'
    });
  }
};

export const createVisita = (visitaData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_VISITA_REQUEST });

    const response = await axios.post('/visita', visitaData);

    dispatch({
      type: CREATE_VISITA_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_VISITA_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Acción para obtener todas las visitas
export const getAllVisitas = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_VISITAS_REQUEST });

    const response = await axios.get('/visitas');

    dispatch({
      type: GET_ALL_VISITAS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_VISITAS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Acción para obtener visitas por propiedad
export const getVisitasByPropertyId = (propertyId) => async (dispatch) => {
  try {
    dispatch({ type: GET_VISITAS_BY_PROPERTY_REQUEST });

    const response = await axios.get(`/visitas/property/${propertyId}`);

    dispatch({
      type: GET_VISITAS_BY_PROPERTY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_VISITAS_BY_PROPERTY_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

export const deleteProperty = (id) => {
  return async (dispatch) => {
    try {
      await axios.delete(`/property/delete/${id}`);
      dispatch({
        type: 'DELETE_PROPERTY',
        payload: id,
      });
    } catch (error) {
      console.error('Error eliminando la propiedad:', error);
    }
  };
};

export const getPropertiesBySeller = (sellerId) => async (dispatch) => {
  try {
    const response = await axios.get(`/properties/seller/true/${sellerId}`);
    // Suponiendo que la respuesta tiene un formato de 'data' para las propiedades
    dispatch({
      type: GET_PROPERTIES_BY_SELLER,
      payload: {
        sellerId,
        properties: response.data.data, // Ajusta según el formato de respuesta real
      },
    });
  } catch (error) {
    if (error.response && error.response.status === 404) {
      // Si no hay propiedades, simplemente despachamos una acción con un conteo de 0
      dispatch({
        type: GET_PROPERTIES_BY_SELLER,
        payload: {
          sellerId,
          properties: [], // Asignar un array vacío si no se encuentran propiedades
        },
      });
    } else {
      // Manejar otros errores
      console.error('Error al obtener propiedades:', error);
      dispatch({
        type: GET_PROPERTIES_BY_SELLER_ERROR,
        payload: error.message,
      });
    }
  }
};


export const fetchRentals = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_RENTALS_REQUEST });

    const { data } = await axios.get('/rentals'); // Cambia la URL según tu backend

    dispatch({
      type: FETCH_RENTALS_SUCCESS,
      payload: data, // Suponemos que 'data' es un array de rentas
    });
  } catch (error) {
    console.error('Error al obtener las rentas:', error);
    dispatch({
      type: FETCH_RENTALS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const fetchRental = (rentalId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_RENTAL_REQUEST });

    const { data } = await axios.get(`/rentals/${rentalId}`); // Cambia la URL según tu backend

    dispatch({
      type: FETCH_RENTAL_SUCCESS,
      payload: data, // Suponemos que 'data' es el objeto de una renta
    });
  } catch (error) {
    console.error('Error al obtener los detalles de la renta:', error);
    dispatch({
      type: FETCH_RENTAL_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Función para cerrar una propiedad (marcar como alquilada)
export const closeProperty = (propertyId) => async (dispatch) => {
  try {
    console.log('=== CERRANDO PROPIEDAD ===');
    console.log('Property ID:', propertyId);
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    // Datos para cerrar la propiedad
    const closeData = {
      cerrado: {
        cierre: true,
        precioCierre: '',
        currencyCierre: '',
        fecha: new Date().toISOString(),
        soldByAgent: true,
        soldByAgency: '',
        buyingTip: false,
        selleringTip: false,
        sellerCommision: '',
        officeComission: '',
        totalComission: '',
        franquiciaComission: '',
        martillerComission: ''
      }
    };

    const { data } = await axios.put(`/properties/${propertyId}`, closeData, config);
    
    console.log('Propiedad cerrada exitosamente:', data);
    return data;
    
  } catch (error) {
    console.error('Error al cerrar la propiedad:', error);
    throw error;
  }
};

export const createRental = (rentalData) => async (dispatch) => {
  try {
    console.log('=== ACCIÓN REDUX: CREATE_RENTAL ===');
    console.log('Datos recibidos en la acción:', rentalData);
    
    dispatch({ type: CREATE_RENTAL_REQUEST });

    // PASO 1: Cerrar la propiedad antes de crear el contrato
    console.log('PASO 1: Cerrando propiedad ID:', rentalData.propertyId);
    await dispatch(closeProperty(rentalData.propertyId));
    
    // PASO 2: Crear el contrato de alquiler
    console.log('PASO 2: Creando contrato de alquiler');
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const apiUrl = '/rental';
    console.log('Enviando POST a:', apiUrl);

    const { data } = await axios.post(apiUrl, rentalData, config);
    
    console.log('Respuesta exitosa del servidor:', data);

    dispatch({
      type: CREATE_RENTAL_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    console.error('=== ERROR EN ACCIÓN REDUX ===');
    console.error('Error completo:', error);
    console.error('Response data:', error.response?.data);
    console.error('Response status:', error.response?.status);

    const errorMessage = error.response?.data?.message ||
                        error.response?.data?.error ||
                        error.message ||
                        'Error desconocido';

    dispatch({
      type: CREATE_RENTAL_FAILURE,
      payload: errorMessage,
    });

    throw error; // Re-lanzar el error para que lo maneje el componente
  }
};

export const updateRental = (rentalId, rentalData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_RENTAL_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.put(`/rental/${rentalId}`, rentalData, config);

    dispatch({
      type: UPDATE_RENTAL_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    console.error('Error al actualizar la renta:', error);
    dispatch({
      type: UPDATE_RENTAL_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const deleteRental = (rentalId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_RENTAL_REQUEST });

    await axios.delete(`/rental/${rentalId}`);

    dispatch({
      type: DELETE_RENTAL_SUCCESS,
      payload: rentalId,
    });

    return { success: true };
  } catch (error) {
    console.error('Error al eliminar la renta:', error);
    dispatch({
      type: DELETE_RENTAL_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Cancela un contrato conservando historial de cuotas (terminated).
export const cancelRental = (rentalId, payload = {}) => async (dispatch) => {
  try {
    dispatch({ type: CANCEL_RENTAL_REQUEST });

    const body = {
      terminationReason: payload.terminationReason,
      ...(payload.terminationDate ? { terminationDate: payload.terminationDate } : {}),
      ...(typeof payload.cancelFuturePayments === 'boolean'
        ? { cancelFuturePayments: payload.cancelFuturePayments }
        : {}),
      ...(typeof payload.releaseProperty === 'boolean'
        ? { releaseProperty: payload.releaseProperty }
        : {}),
      ...(payload.cancelledBy ? { cancelledBy: payload.cancelledBy } : {}),
    };

    const { data } = await axios.put(
      `/rentals/admin/${rentalId}/cancel`,
      body,
      { headers: { 'Content-Type': 'application/json' } }
    );

    dispatch({
      type: CANCEL_RENTAL_SUCCESS,
      payload: data?.data || data,
    });

    return data?.data || data;
  } catch (error) {
    console.error('Error al cancelar el contrato:', error);
    dispatch({
      type: CANCEL_RENTAL_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Reactiva un contrato cancelado.
export const reactivateRental = (rentalId) => async (dispatch) => {
  try {
    dispatch({ type: REACTIVATE_RENTAL_REQUEST });

    const { data } = await axios.put(
      `/rentals/admin/${rentalId}/reactivate`,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );

    dispatch({
      type: REACTIVATE_RENTAL_SUCCESS,
      payload: data?.data || data,
    });

    return data?.data || data;
  } catch (error) {
    console.error('Error al reactivar el contrato:', error);
    dispatch({
      type: REACTIVATE_RENTAL_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const getClosedProperties = (filters) => async (dispatch) => {
  try {
    dispatch({ type: GET_CLOSED_PROPERTIES_REQUEST });

    // Construir la query string a partir de los filtros
    const query = new URLSearchParams(filters).toString();
    const response = await axios.get(`/properties/closed?${query}`); // Agregar los filtros a la URL

    dispatch({
      type: GET_CLOSED_PROPERTIES_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    console.error('Error al obtener propiedades cerradas:', error);
    dispatch({
      type: GET_CLOSED_PROPERTIES_FAIL,
      payload: error.message || 'Error al obtener propiedades cerradas',
    });
  }
};

// Obtener todos los eventos (con filtros opcionales)
export const fetchEvents = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_EVENTS_REQUEST });
  try {
    const query = new URLSearchParams();
    if (filters.desde) query.append('desde', filters.desde);
    if (filters.hasta) query.append('hasta', filters.hasta);
    if (filters.tipo) query.append('tipo', filters.tipo);
    if (filters.estado) query.append('estado', filters.estado);
    if (filters.agente) query.append('agente', filters.agente);
    if (filters.agenteTipo) query.append('agenteTipo', filters.agenteTipo);
    if (filters.creador) query.append('creador', filters.creador);
    if (filters.creadorTipo) query.append('creadorTipo', filters.creadorTipo);
    const qs = query.toString();
    const res = await axios.get(`/eventos${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_EVENTS_SUCCESS, payload: res.data.data });
  } catch (error) {
    dispatch({ type: FETCH_EVENTS_FAIL, payload: error.message });
  }
};

// Obtener evento por ID
export const fetchEventById = (id) => async (dispatch) => {
  dispatch({ type: FETCH_EVENT_BY_ID_REQUEST });
  try {
    const res = await axios.get(`/eventos/${id}`);
    dispatch({ type: FETCH_EVENT_BY_ID_SUCCESS, payload: res.data.data });
    return res.data.data;
  } catch (error) {
    dispatch({ type: FETCH_EVENT_BY_ID_FAIL, payload: error.message });
  }
};

// Crear evento
export const createEvent = (eventData) => async (dispatch) => {
  dispatch({ type: CREATE_EVENT_REQUEST });
  try {
    const res = await axios.post('/eventos', eventData);
    dispatch({ type: CREATE_EVENT_SUCCESS, payload: res.data.data });
    return res.data.data;
  } catch (error) {
    dispatch({ type: CREATE_EVENT_FAIL, payload: error.message });
    throw error;
  }
};

// Editar evento
export const updateEvent = (id, eventData) => async (dispatch) => {
  dispatch({ type: UPDATE_EVENT_REQUEST });
  try {
    const res = await axios.put(`/eventos/${id}`, eventData);
    dispatch({ type: UPDATE_EVENT_SUCCESS, payload: res.data.data });
    return res.data.data;
  } catch (error) {
    dispatch({ type: UPDATE_EVENT_FAIL, payload: error.message });
    throw error;
  }
};

// Eliminar evento
export const deleteEvent = (id) => async (dispatch) => {
  dispatch({ type: DELETE_EVENT_REQUEST });
  try {
    await axios.delete(`/eventos/${id}`);
    dispatch({ type: DELETE_EVENT_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_EVENT_FAIL, payload: error.message });
    throw error;
  }
};

// Eventos próximos (para notificaciones)
export const fetchUpcomingEvents = (dias = 7, agenteId, agenteTipo) => async (dispatch) => {
  dispatch({ type: FETCH_UPCOMING_EVENTS_REQUEST });
  try {
    const query = new URLSearchParams();
    query.append('dias', dias);
    if (agenteId) query.append('agente', agenteId);
    if (agenteTipo) query.append('agenteTipo', agenteTipo);
    const res = await axios.get(`/eventos/proximos?${query.toString()}`);
    dispatch({ type: FETCH_UPCOMING_EVENTS_SUCCESS, payload: res.data.data });
  } catch (error) {
    dispatch({ type: FETCH_UPCOMING_EVENTS_FAIL, payload: error.message });
  }
};

// Marcar evento como visto por un agente
export const markEventSeen = (eventoId, sellerId, tipo = 'SELLER') => async (dispatch) => {
  dispatch({ type: MARK_EVENT_SEEN_REQUEST });
  try {
    const res = await axios.put(`/eventos/${eventoId}/agentes/${sellerId}/visto`, { tipo });
    dispatch({ type: MARK_EVENT_SEEN_SUCCESS, payload: { eventoId, sellerId, tipo, data: res.data.data } });
  } catch (error) {
    dispatch({ type: MARK_EVENT_SEEN_FAIL, payload: error.message });
  }
};

// Cambiar estado del evento
export const changeEventStatus = (eventoId, estado) => async (dispatch) => {
  dispatch({ type: CHANGE_EVENT_STATUS_REQUEST });
  try {
    const res = await axios.put(`/eventos/${eventoId}/estado`, { estado });
    dispatch({ type: CHANGE_EVENT_STATUS_SUCCESS, payload: res.data.data });
  } catch (error) {
    dispatch({ type: CHANGE_EVENT_STATUS_FAIL, payload: error.message });
  }
};

// ================ CLIENT ACTIONS ================

// Crear cliente
export const createClient = (clientData) => async (dispatch) => {
  dispatch({ type: CREATE_CLIENT_REQUEST });
  try {
    const res = await axios.post('/clients', clientData);
    dispatch({ type: CREATE_CLIENT_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: CREATE_CLIENT_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Obtener clientes por seller
export const getClientsBySeller = (sellerId, params = {}) => async (dispatch) => {
  dispatch({ type: GET_CLIENTS_BY_SELLER_REQUEST });
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(`/clients/seller/${sellerId}${query ? `?${query}` : ''}`);
    dispatch({ type: GET_CLIENTS_BY_SELLER_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: GET_CLIENTS_BY_SELLER_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Obtener todos los clientes (Admin)
export const getAllClients = (params = {}) => async (dispatch) => {
  dispatch({ type: GET_ALL_CLIENTS_REQUEST });
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(`/clients${query ? `?${query}` : ''}`);
    dispatch({ type: GET_ALL_CLIENTS_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: GET_ALL_CLIENTS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Obtener cliente por ID
export const getClientById = (clientId) => async (dispatch) => {
  dispatch({ type: GET_CLIENT_BY_ID_REQUEST });
  try {
    const res = await axios.get(`/clients/${clientId}`);
    dispatch({ type: GET_CLIENT_BY_ID_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: GET_CLIENT_BY_ID_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Actualizar cliente
export const updateClient = (clientId, clientData) => async (dispatch) => {
  dispatch({ type: UPDATE_CLIENT_REQUEST });
  try {
    const res = await axios.put(`/clients/${clientId}`, clientData);
    dispatch({ type: UPDATE_CLIENT_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: UPDATE_CLIENT_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Eliminar cliente (soft delete)
export const deleteClient = (clientId) => async (dispatch) => {
  dispatch({ type: DELETE_CLIENT_REQUEST });
  try {
    const res = await axios.delete(`/clients/${clientId}`);
    dispatch({ type: DELETE_CLIENT_SUCCESS, payload: { clientId, ...res.data } });
    return res.data;
  } catch (error) {
    dispatch({ type: DELETE_CLIENT_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Asociar cliente con propiedad
export const associateClientProperty = (clientId, propertyId, associationData) => async (dispatch) => {
  dispatch({ type: ASSOCIATE_CLIENT_PROPERTY_REQUEST });
  try {
    const res = await axios.post(`/clients/${clientId}/properties/${propertyId}`, associationData);
    dispatch({ type: ASSOCIATE_CLIENT_PROPERTY_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: ASSOCIATE_CLIENT_PROPERTY_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Obtener clientes interesados en una propiedad
export const getClientsByProperty = (propertyId, params = {}) => async (dispatch) => {
  dispatch({ type: GET_CLIENTS_BY_PROPERTY_REQUEST });
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(`/clients/property/${propertyId}${query ? `?${query}` : ''}`);
    dispatch({ type: GET_CLIENTS_BY_PROPERTY_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({ type: GET_CLIENTS_BY_PROPERTY_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// ================ RENTAL MANAGEMENT ACTIONS ================

// Log centralizado: evita repetir console.error en cada catch de acciones de rentals regulares.
const rentalErrorPayload = (error) => {
  const message = error.response?.data?.message || error.message;
  console.error('[Rentals] Error:', message, error?.response?.data || error);
  return message;
};

// Dashboard y vistas generales.
// Acepta un objeto opcional de filtros compuestos:
//   { sellerId, propertyId, officeId, rentalId, status, currency,
//     dateFrom, dateTo, dateField, days }
export const fetchRentalDashboard = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_RENTAL_DASHBOARD_REQUEST });
  try {
    const params = {
      ...buildRentalFilterParams(filters),
      ...(filters?.days ? { days: filters.days } : {}),
    };
    const response = await axios.get('/rentals/admin/dashboard', { params });
    dispatch({
      type: FETCH_RENTAL_DASHBOARD_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RENTAL_DASHBOARD_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const fetchRentalOverview = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_RENTAL_OVERVIEW_REQUEST });
  try {
    const params = {
      type: filters.type || 'all',
      ...buildRentalFilterParams(filters),
      ...(filters?.days ? { days: filters.days } : {}),
      ...(filters?.page != null ? { page: filters.page } : {}),
      ...(filters?.limit != null ? { limit: filters.limit } : {}),
    };
    const response = await axios.get('/rentals/admin/overview', { params });
    const payload = response.data?.data || response.data || null;
    dispatch({
      type: FETCH_RENTAL_OVERVIEW_SUCCESS,
      payload,
    });
    return payload;
  } catch (error) {
    dispatch({
      type: FETCH_RENTAL_OVERVIEW_FAIL,
      payload: rentalErrorPayload(error),
    });
    throw error;
  }
};

const buildActiveRentalsMeta = (body = {}) => ({
  total: body?.total ?? body?.count ?? null,
  count: body?.count ?? null,
  page: body?.page ?? null,
  limit: body?.limit ?? null,
  totalPages: body?.totalPages ?? null,
});

// Listado de contratos activos. Firma polimórfica:
//   - fetchActiveRentals(filtersObj)  // recomendado: { sellerId, propertyId, ..., page, limit, status }
//   - fetchActiveRentals(page, limit, status)  // back-compat
export const fetchActiveRentals = (...args) => async (dispatch) => {
  let filters = {};
  if (args.length === 1 && args[0] && typeof args[0] === 'object') {
    filters = { ...args[0] };
  } else {
    const [page = 1, limit = 20, status = 'active'] = args;
    filters = { page, limit, status };
  }

  dispatch({ type: FETCH_ACTIVE_RENTALS_REQUEST });
  try {
    const params = {
      ...buildRentalFilterParams(filters),
      ...(filters?.page != null ? { page: filters.page } : {}),
      ...(filters?.limit != null ? { limit: filters.limit } : {}),
    };
    const response = await axios.get('/rentals/admin/active', { params });
    const body = response.data || {};
    dispatch({
      type: FETCH_ACTIVE_RENTALS_SUCCESS,
      payload: {
        data: body.data || [],
        meta: buildActiveRentalsMeta(body),
      },
    });
    return body;
  } catch (error) {
    dispatch({
      type: FETCH_ACTIVE_RENTALS_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

// Reporte de cuotas (Excel). No mantiene estado en el reducer:
// retorna { columns, data, count, filters } directamente.
// Acepta filtros compuestos + parámetros propios del reporte
// (from, to, month, orderBy, order, timeFrom, timeTo).
export const fetchPaymentsExcel = (filters = {}) => async () => {
  const params = {
    ...buildRentalFilterParams(filters),
    ...(filters.from ? { from: filters.from } : {}),
    ...(filters.to ? { to: filters.to } : {}),
    ...(filters.month ? { month: filters.month } : {}),
    ...(filters.orderBy ? { orderBy: filters.orderBy } : {}),
    ...(filters.order ? { order: filters.order } : {}),
    ...(filters.timeFrom ? { timeFrom: filters.timeFrom } : {}),
    ...(filters.timeTo ? { timeTo: filters.timeTo } : {}),
  };
  const response = await axios.get('/rentals/admin/reports/payments-excel', { params });
  const body = response.data || {};
  // El backend puede devolver { columns, data, count } directamente o anidado en .data
  if (Array.isArray(body?.columns) && Array.isArray(body?.data)) return body;
  if (body?.data && (Array.isArray(body.data?.columns) || Array.isArray(body.data?.data))) {
    return body.data;
  }
  return body;
};

export const fetchRentalDetail = (rentalId) => async (dispatch) => {
  dispatch({ type: FETCH_RENTAL_DETAIL_REQUEST });
  try {
    const response = await axios.get(`/rentals/admin/${rentalId}`);
    dispatch({
      type: FETCH_RENTAL_DETAIL_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RENTAL_DETAIL_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const fetchOverduePayments = () => async (dispatch) => {
  dispatch({ type: FETCH_OVERDUE_PAYMENTS_REQUEST });
  try {
    const response = await axios.get('/rentals/overdue/payments/all');
    dispatch({
      type: FETCH_OVERDUE_PAYMENTS_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({
      type: FETCH_OVERDUE_PAYMENTS_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const fetchExpiringContracts = (days = 30) => async (dispatch) => {
  dispatch({ type: FETCH_EXPIRING_CONTRACTS_REQUEST });
  try {
    const response = await axios.get(`/rentals/admin/expiring?days=${days}`);
    dispatch({
      type: FETCH_EXPIRING_CONTRACTS_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      '';

    const isInvalidRentalIdError =
      typeof backendMessage === 'string' &&
      backendMessage.toLowerCase().includes('rentalid inválido');

    if (isInvalidRentalIdError) {
      try {
        const fallbackResponse = await axios.get('/rentals/admin/active?status=active');
        const activeContracts = fallbackResponse.data?.data || [];
        const today = new Date();
        const limitDate = new Date();
        limitDate.setDate(limitDate.getDate() + Number(days || 30));

        const expiringFromActive = activeContracts.filter((contract) => {
          if (!contract?.contractEnd) return false;
          const endDate = new Date(contract.contractEnd);
          return endDate >= today && endDate <= limitDate;
        });

        dispatch({
          type: FETCH_EXPIRING_CONTRACTS_SUCCESS,
          payload: expiringFromActive
        });
        return;
      } catch (fallbackError) {
        dispatch({
          type: FETCH_EXPIRING_CONTRACTS_FAIL,
          payload:
            fallbackError.response?.data?.message ||
            fallbackError.response?.data?.error ||
            fallbackError.message
        });
        return;
      }
    }

    dispatch({
      type: FETCH_EXPIRING_CONTRACTS_FAIL,
      payload: backendMessage
    });
  }
};

// Gestión de pagos/cuotas
export const generatePaymentSchedule = (rentalId) => async (dispatch) => {
  dispatch({ type: GENERATE_PAYMENT_SCHEDULE_REQUEST });
  try {
    const response = await axios.post(`/rentals/admin/${rentalId}/generate-payments`);
    dispatch({
      type: GENERATE_PAYMENT_SCHEDULE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: GENERATE_PAYMENT_SCHEDULE_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

export const fetchRentalPayments = (rentalId, status = null) => async (dispatch) => {
  dispatch({ type: FETCH_RENTAL_PAYMENTS_REQUEST });
  try {
    const url = status 
      ? `/rentals/admin/${rentalId}/payments?status=${status}`
      : `/rentals/admin/${rentalId}/payments`;
    const response = await axios.get(url);
    // Guardar toda la respuesta: { data: [...], contractInfo: {...} }
    dispatch({
      type: FETCH_RENTAL_PAYMENTS_SUCCESS,
      payload: response.data // Ahora incluye data y contractInfo
    });
  } catch (error) {
    dispatch({
      type: FETCH_RENTAL_PAYMENTS_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const registerPayment = (paymentId, paymentData) => async (dispatch) => {
  dispatch({ type: REGISTER_PAYMENT_REQUEST });
  try {
    const response = await axios.put(`/rentals/admin/payments/${paymentId}/register`, paymentData);
    dispatch({
      type: REGISTER_PAYMENT_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: REGISTER_PAYMENT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

export const updateOverduePayments = () => async (dispatch) => {
  dispatch({ type: UPDATE_OVERDUE_PAYMENTS_REQUEST });
  try {
    const response = await axios.put('/rentals/overdue/payments/update-overdue/all');
    dispatch({
      type: UPDATE_OVERDUE_PAYMENTS_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_OVERDUE_PAYMENTS_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

// Gestión de ajustes/aumentos
export const createRentalAdjustment = (rentalId, adjustmentData) => async (dispatch) => {
  dispatch({ type: CREATE_RENTAL_ADJUSTMENT_REQUEST });
  try {
    const response = await axios.post(`/rentals/admin/${rentalId}/adjustments`, adjustmentData);
    dispatch({
      type: CREATE_RENTAL_ADJUSTMENT_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_RENTAL_ADJUSTMENT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

export const simulateRentalAdjustment = (rentalId, adjustmentData) => async (dispatch) => {
  dispatch({ type: SIMULATE_RENTAL_ADJUSTMENT_REQUEST });
  try {
    const response = await axios.post(`/rentals/admin/${rentalId}/adjustments/simulate`, adjustmentData);
    dispatch({
      type: SIMULATE_RENTAL_ADJUSTMENT_SUCCESS,
      payload: response.data.simulation
    });
    return response.data.simulation;
  } catch (error) {
    dispatch({
      type: SIMULATE_RENTAL_ADJUSTMENT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

export const fetchAdjustmentHistory = (rentalId) => async (dispatch) => {
  dispatch({ type: FETCH_ADJUSTMENT_HISTORY_REQUEST });
  try {
    const response = await axios.get(`/rentals/admin/${rentalId}/adjustments/history`);
    dispatch({
      type: FETCH_ADJUSTMENT_HISTORY_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADJUSTMENT_HISTORY_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const fetchUpcomingAdjustments = (days = 60) => async (dispatch) => {
  dispatch({ type: FETCH_UPCOMING_ADJUSTMENTS_REQUEST });
  try {
    const response = await axios.get(`/rentals/admin/adjustments/upcoming?days=${days}`);
    dispatch({
      type: FETCH_UPCOMING_ADJUSTMENTS_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_UPCOMING_ADJUSTMENTS_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const notifyAdjustment = (adjustmentId) => async (dispatch) => {
  dispatch({ type: NOTIFY_ADJUSTMENT_REQUEST });
  try {
    const response = await axios.put(`/rentals/admin/adjustments/${adjustmentId}/notify`);
    dispatch({
      type: NOTIFY_ADJUSTMENT_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: NOTIFY_ADJUSTMENT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

// Gestión de inquilinos
export const createRentalTenant = (rentalId, tenantData) => async (dispatch) => {
  dispatch({ type: CREATE_RENTAL_TENANT_REQUEST });
  try {
    const response = await axios.post(`/rentals/admin/${rentalId}/tenants`, tenantData);
    dispatch({
      type: CREATE_RENTAL_TENANT_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_RENTAL_TENANT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

export const fetchRentalTenants = (rentalId) => async (dispatch) => {
  dispatch({ type: FETCH_RENTAL_TENANTS_REQUEST });
  try {
    const response = await axios.get(`/rentals/admin/${rentalId}/tenants`);
    dispatch({
      type: FETCH_RENTAL_TENANTS_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RENTAL_TENANTS_FAIL,
      payload: rentalErrorPayload(error)
    });
  }
};

export const updateRentalTenant = (tenantId, tenantData) => async (dispatch) => {
  dispatch({ type: UPDATE_RENTAL_TENANT_REQUEST });
  try {
    const response = await axios.put(`/rentals/admin/tenants/${tenantId}`, tenantData);
    dispatch({
      type: UPDATE_RENTAL_TENANT_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_RENTAL_TENANT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

export const deleteRentalTenant = (tenantId) => async (dispatch) => {
  dispatch({ type: DELETE_RENTAL_TENANT_REQUEST });
  try {
    const response = await axios.delete(`/rentals/admin/tenants/${tenantId}`);
    dispatch({
      type: DELETE_RENTAL_TENANT_SUCCESS,
      payload: { tenantId, ...response.data }
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: DELETE_RENTAL_TENANT_FAIL,
      payload: rentalErrorPayload(error)
    });
    throw error;
  }
};

// Utilidades
export const clearRentalState = () => ({ type: CLEAR_RENTAL_STATE });

// ================ ESTADÍSTICAS ACTIONS ================

// Módulo 1: Estadísticas de Visitas (global)
export const fetchVisitasStats = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_VISITAS_STATS_REQUEST });
  try {
    const query = new URLSearchParams();
    if (params.top) query.append('top', params.top);
    if (params.minVisitsForRanking) query.append('minVisitsForRanking', params.minVisitsForRanking);
    const qs = query.toString();
    const response = await axios.get(`/visitas/stats${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_VISITAS_STATS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VISITAS_STATS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Módulo 1: Estadísticas de Visitas por período
export const fetchVisitasStatsPeriod = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_VISITAS_STATS_PERIOD_REQUEST });
  try {
    const query = new URLSearchParams();
    if (params.startDate) query.append('startDate', params.startDate);
    if (params.endDate) query.append('endDate', params.endDate);
    if (params.top) query.append('top', params.top);
    if (params.minVisitsForRanking) query.append('minVisitsForRanking', params.minVisitsForRanking);
    if (params.comparePrevious !== undefined) query.append('comparePrevious', params.comparePrevious);
    const qs = query.toString();
    const response = await axios.get(`/visitas/stats/period${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_VISITAS_STATS_PERIOD_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VISITAS_STATS_PERIOD_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Módulo 1b: Estadísticas de Visitas por Agente
export const fetchVisitasAgentStats = (agente, params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_VISITAS_AGENT_STATS_REQUEST });
  try {
    const query = new URLSearchParams();
    if (params.top) query.append('top', params.top);
    if (params.minVisitsForRanking) query.append('minVisitsForRanking', params.minVisitsForRanking);
    const qs = query.toString();
    const response = await axios.get(`/visitas/agent/${encodeURIComponent(agente)}/stats${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_VISITAS_AGENT_STATS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VISITAS_AGENT_STATS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Módulo 2: Productividad de Agentes
export const fetchSellersStats = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_SELLERS_STATS_REQUEST });
  try {
    const query = new URLSearchParams();
    const allowedParams = [
      'includeDetails', 'startDate', 'endDate', 'granularity', 'operation',
      'sellerId', 'officeId', 'martillerId', 'includeActivity',
      'includeTimeseries', 'includeSellerTimeseries', 'includeInactiveSellers',
      'comparePrevious', 'topN',
    ];
    allowedParams.forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
    const qs = query.toString();
    const response = await axios.get(`/sellers/stats/properties${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_SELLERS_STATS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_SELLERS_STATS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Módulo 3: Ranking de Reuniones
export const fetchReunionesRanking = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_RANKING_REQUEST });
  try {
    const query = new URLSearchParams();
    if (params.year) query.append('year', params.year);
    if (params.orderBy) query.append('orderBy', params.orderBy);
    const qs = query.toString();
    const response = await axios.get(`/reuniones/ranking${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_REUNIONES_RANKING_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_RANKING_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Módulo 3: Informe Individual de Reuniones
export const fetchReunionesInforme = (sellerId, year) => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_INFORME_REQUEST });
  try {
    const query = year ? `?year=${year}` : '';
    const response = await axios.get(`/reuniones/informe/${sellerId}${query}`);
    dispatch({ type: FETCH_REUNIONES_INFORME_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_INFORME_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Módulo 3: Tips personalizados
export const fetchReunionesTips = (sellerId, year) => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_TIPS_REQUEST });
  try {
    const query = year ? `?year=${year}` : '';
    const response = await axios.get(`/reuniones/tips/${sellerId}${query}`);
    dispatch({ type: FETCH_REUNIONES_TIPS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_TIPS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const clearEstadisticasState = () => ({ type: CLEAR_ESTADISTICAS_STATE });

// Reuniones CRUD: Crear reunión
export const createReunion = (data) => async (dispatch) => {
  dispatch({ type: CREATE_REUNION_REQUEST });
  try {
    const response = await axios.post('/reuniones', data);
    dispatch({ type: CREATE_REUNION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_REUNION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Reuniones CRUD: Actualizar reunión
export const updateReunion = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_REUNION_REQUEST });
  try {
    const response = await axios.put(`/reuniones/${encodeURIComponent(id)}`, data);
    dispatch({ type: UPDATE_REUNION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_REUNION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Reuniones CRUD: Eliminar reunión
export const deleteReunion = (id) => async (dispatch) => {
  dispatch({ type: DELETE_REUNION_REQUEST });
  try {
    const response = await axios.delete(`/reuniones/${encodeURIComponent(id)}`);
    dispatch({ type: DELETE_REUNION_SUCCESS, payload: id });
    return response.data;
  } catch (error) {
    dispatch({ type: DELETE_REUNION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Reuniones: Listar con filtros
export const fetchReunionesList = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_LIST_REQUEST });
  try {
    const query = new URLSearchParams();
    if (params.sellerId) query.append('sellerId', params.sellerId);
    if (params.mes) query.append('mes', params.mes);
    if (params.desde) query.append('desde', params.desde);
    if (params.hasta) query.append('hasta', params.hasta);
    if (params.page) query.append('page', params.page);
    if (params.limit) query.append('limit', params.limit);
    const qs = query.toString();
    const response = await axios.get(`/reuniones${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_REUNIONES_LIST_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_LIST_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Agentes activos para selector de reuniones
export const fetchActiveSellers = () => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVE_SELLERS_REQUEST });
  try {
    const response = await axios.get('/sellers/active');
    dispatch({ type: FETCH_ACTIVE_SELLERS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_ACTIVE_SELLERS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Reuniones V2: Dashboard global
export const fetchReunionesDashboard = () => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_DASHBOARD_REQUEST });
  try {
    const response = await axios.get('/reuniones/dashboard');
    dispatch({ type: FETCH_REUNIONES_DASHBOARD_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_DASHBOARD_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Reuniones V2: Comparativa 1v1
export const fetchReunionesComparativa = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_COMPARATIVA_REQUEST });
  try {
    const query = new URLSearchParams();
    if (params.agent1) query.append('agent1', params.agent1);
    if (params.agent2) query.append('agent2', params.agent2);
    if (params.mes) query.append('mes', params.mes);
    if (params.desde) query.append('desde', params.desde);
    if (params.hasta) query.append('hasta', params.hasta);
    const qs = query.toString();
    const response = await axios.get(`/reuniones/comparativa${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_REUNIONES_COMPARATIVA_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_COMPARATIVA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Reuniones V2: Resumen anual
export const fetchReunionesAnual = (sellerId, year) => async (dispatch) => {
  dispatch({ type: FETCH_REUNIONES_ANUAL_REQUEST });
  try {
    const query = year ? `?year=${year}` : '';
    const response = await axios.get(`/reuniones/anual/${encodeURIComponent(sellerId)}${query}`);
    dispatch({ type: FETCH_REUNIONES_ANUAL_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REUNIONES_ANUAL_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// ================ VISITAS EXTERNAS ================

export const createVisitaExterna = (data) => async (dispatch) => {
  dispatch({ type: CREATE_VISITA_EXTERNA_REQUEST });
  try {
    const response = await axios.post('/visita-externa', data);
    dispatch({ type: CREATE_VISITA_EXTERNA_SUCCESS, payload: response.data.visita });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_VISITA_EXTERNA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const getVisitasExternas = () => async (dispatch) => {
  dispatch({ type: GET_VISITAS_EXTERNAS_REQUEST });
  try {
    const response = await axios.get('/visitas-externas');
    dispatch({ type: GET_VISITAS_EXTERNAS_SUCCESS, payload: response.data.visitas || [] });
    return response.data;
  } catch (error) {
    if (error.response?.status === 204) {
      dispatch({ type: GET_VISITAS_EXTERNAS_SUCCESS, payload: [] });
      return { visitas: [] };
    }
    dispatch({ type: GET_VISITAS_EXTERNAS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const getVisitasExternasByAgent = (agente) => async (dispatch) => {
  dispatch({ type: GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST });
  try {
    const response = await axios.get(`/visitas-externas/agent/${encodeURIComponent(agente)}`);
    dispatch({ type: GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS, payload: response.data.visitas || [] });
    return response.data;
  } catch (error) {
    if (error.response?.status === 204) {
      dispatch({ type: GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS, payload: [] });
      return { visitas: [] };
    }
    dispatch({ type: GET_VISITAS_EXTERNAS_BY_AGENT_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const updateVisitaExterna = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_VISITA_EXTERNA_REQUEST });
  try {
    const response = await axios.put(`/visita-externa/${id}`, data);
    dispatch({ type: UPDATE_VISITA_EXTERNA_SUCCESS, payload: response.data.visita });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_VISITA_EXTERNA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const deleteVisitaExterna = (id) => async (dispatch) => {
  dispatch({ type: DELETE_VISITA_EXTERNA_REQUEST });
  try {
    await axios.delete(`/visita-externa/${id}`);
    dispatch({ type: DELETE_VISITA_EXTERNA_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_VISITA_EXTERNA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};
export const setRentalLoading = (loading) => ({ type: SET_RENTAL_LOADING, payload: loading });

// ==================== OPERACIONES EXTERNAS (PUNTA COMPRADORA) ====================

export const createOperacionExterna = (data) => async (dispatch) => {
  dispatch({ type: CREATE_OPERACION_EXTERNA_REQUEST });
  try {
    const response = await axios.post('/operacion-externa', data);
    dispatch({ type: CREATE_OPERACION_EXTERNA_SUCCESS, payload: response.data.operacion });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_OPERACION_EXTERNA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const getOperacionesExternas = () => async (dispatch) => {
  dispatch({ type: GET_OPERACIONES_EXTERNAS_REQUEST });
  try {
    const response = await axios.get('/operaciones-externas');
    if (response.status === 204) {
      dispatch({ type: GET_OPERACIONES_EXTERNAS_SUCCESS, payload: [] });
      return;
    }
    dispatch({ type: GET_OPERACIONES_EXTERNAS_SUCCESS, payload: response.data.operaciones || [] });
  } catch (error) {
    dispatch({ type: GET_OPERACIONES_EXTERNAS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const getOperacionExternaById = (id) => async (dispatch) => {
  dispatch({ type: GET_OPERACION_EXTERNA_BY_ID_REQUEST });
  try {
    const response = await axios.get(`/operacion-externa/${id}`);
    dispatch({ type: GET_OPERACION_EXTERNA_BY_ID_SUCCESS, payload: response.data.operacion });
    return response.data;
  } catch (error) {
    dispatch({ type: GET_OPERACION_EXTERNA_BY_ID_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const updateOperacionExterna = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_OPERACION_EXTERNA_REQUEST });
  try {
    const response = await axios.put(`/operacion-externa/${id}`, data);
    dispatch({ type: UPDATE_OPERACION_EXTERNA_SUCCESS, payload: response.data.operacion });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_OPERACION_EXTERNA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const deleteOperacionExterna = (id) => async (dispatch) => {
  dispatch({ type: DELETE_OPERACION_EXTERNA_REQUEST });
  try {
    await axios.delete(`/operacion-externa/${id}`);
    dispatch({ type: DELETE_OPERACION_EXTERNA_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_OPERACION_EXTERNA_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// ================ PROPERTY VERSIONING & APPROVAL ================

export const fetchPropertyVersions = (propertyId) => async (dispatch) => {
  dispatch({ type: FETCH_PROPERTY_VERSIONS_REQUEST });
  try {
    const response = await axios.get(`/properties/${propertyId}/versions`);
    dispatch({ type: FETCH_PROPERTY_VERSIONS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_PROPERTY_VERSIONS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const revertPropertyVersion = (versionId, sellerId) => async (dispatch) => {
  dispatch({ type: REVERT_PROPERTY_VERSION_REQUEST });
  try {
    const response = await axios.post(`/properties/versions/${versionId}/revert`, { sellerId });
    dispatch({ type: REVERT_PROPERTY_VERSION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: REVERT_PROPERTY_VERSION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchPropertyComments = (propertyId) => async (dispatch) => {
  dispatch({ type: FETCH_PROPERTY_COMMENTS_REQUEST });
  try {
    const response = await axios.get(`/properties/${propertyId}/comments`);
    dispatch({ type: FETCH_PROPERTY_COMMENTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_PROPERTY_COMMENTS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const addPropertyComment = (propertyId, commentData) => async (dispatch) => {
  dispatch({ type: ADD_PROPERTY_COMMENT_REQUEST });
  try {
    const response = await axios.post(`/properties/${propertyId}/comments`, commentData);
    dispatch({ type: ADD_PROPERTY_COMMENT_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: ADD_PROPERTY_COMMENT_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const markCommentRead = (commentId) => async (dispatch) => {
  try {
    await axios.put(`/properties/comments/${commentId}/read`);
    dispatch({ type: MARK_COMMENT_READ_SUCCESS, payload: commentId });
  } catch (error) {
    dispatch({ type: MARK_COMMENT_READ_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const approveProperty = (propertyId, data) => async (dispatch) => {
  dispatch({ type: APPROVE_PROPERTY_REQUEST });
  try {
    const response = await axios.post(`/properties/${propertyId}/approve`, data);
    dispatch({ type: APPROVE_PROPERTY_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: APPROVE_PROPERTY_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const rejectProperty = (propertyId, data) => async (dispatch) => {
  dispatch({ type: REJECT_PROPERTY_REQUEST });
  try {
    const response = await axios.post(`/properties/${propertyId}/reject`, data);
    dispatch({ type: REJECT_PROPERTY_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: REJECT_PROPERTY_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const requestRevision = (propertyId, data) => async (dispatch) => {
  dispatch({ type: REQUEST_REVISION_REQUEST });
  try {
    const response = await axios.post(`/properties/${propertyId}/revision`, data);
    dispatch({ type: REQUEST_REVISION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: REQUEST_REVISION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Aprobación de documentación (martillero). No publica; deja pendiente de alta.
export const approveDocumentation = (propertyId, data) => async (dispatch) => {
  dispatch({ type: APPROVE_DOCUMENTATION_REQUEST });
  try {
    const response = await axios.post(`/properties/${propertyId}/documentation/approve`, data);
    dispatch({ type: APPROVE_DOCUMENTATION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: APPROVE_DOCUMENTATION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Rechazo/revocación de documentación (martillero). Despublica la propiedad.
export const rejectDocumentation = (propertyId, data) => async (dispatch) => {
  dispatch({ type: REJECT_DOCUMENTATION_REQUEST });
  try {
    const response = await axios.post(`/properties/${propertyId}/documentation/reject`, data);
    dispatch({ type: REJECT_DOCUMENTATION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: REJECT_DOCUMENTATION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchDocumentationStatus = (propertyId) => async (dispatch) => {
  dispatch({ type: FETCH_DOCUMENTATION_STATUS_REQUEST });
  try {
    const response = await axios.get(`/properties/${propertyId}/documentation/status`);
    dispatch({ type: FETCH_DOCUMENTATION_STATUS_SUCCESS, payload: response.data.data });
    return response.data.data;
  } catch (error) {
    dispatch({ type: FETCH_DOCUMENTATION_STATUS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// Listado unificado de revisión con filtros + contadores por bucket.
export const getReviewProperties = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_REVIEW_PROPERTIES_REQUEST });
  try {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, value);
      }
    });
    const qs = query.toString();
    const response = await axios.get(`/properties/review${qs ? `?${qs}` : ''}`);
    dispatch({ type: FETCH_REVIEW_PROPERTIES_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_REVIEW_PROPERTIES_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// ================ VRC ================

// Helper interno: extrae sellerId/role del FormData (si están) y los devuelve
// para anexarlos a la URL como query string. Esto garantiza que el backend
// vea siempre la identidad aunque el parser multipart no exponga los campos
// de texto a tiempo en req.body.
const extractAuthParamsFromFormData = (fd) => {
  const params = {};
  try {
    if (fd && typeof fd.get === 'function') {
      const sid = fd.get('sellerId');
      const role = fd.get('role');
      if (sid) params.sellerId = String(sid);
      if (role) params.role = String(role);
    }
  } catch (_) { /* no-op */ }
  if (!params.sellerId && typeof window !== 'undefined') {
    const sid = localStorage.getItem('userId');
    if (sid) params.sellerId = sid;
  }
  if (!params.role && typeof window !== 'undefined') {
    const r = (localStorage.getItem('userType') || '').toLowerCase();
    if (r) params.role = r;
  }
  return params;
};

// Construye config { params } para axios. El backend (vrcAuth) busca el
// sellerId en headers 'x-seller-id'/'x-user-id', body o query. Usamos
// SOLO query params para evitar preflight CORS (los headers custom
// requieren que el backend los liste en Access-Control-Allow-Headers).
const buildVRCAuthConfig = (fd) => {
  const params = extractAuthParamsFromFormData(fd);
  return { params };
};

export const createVRC = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_VRC_REQUEST });
  try {
    // NO setear Content-Type manualmente: axios/browser lo arman con el boundary correcto
    const response = await axios.post('/vrc', formData, buildVRCAuthConfig(formData));
    dispatch({ type: CREATE_VRC_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_VRC_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchVRCs = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_VRCS_REQUEST });
  try {
    const cfg = buildVRCAuthConfig(null);
    const response = await axios.get('/vrc', { ...cfg, params: { ...cfg.params, ...params } });
    dispatch({ type: FETCH_VRCS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VRCS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchVRCsByAgent = (sellerId, params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_VRCS_REQUEST });
  try {
    const cfg = buildVRCAuthConfig(null);
    const response = await axios.get(`/vrc/agente/${sellerId}`, { ...cfg, params: { ...cfg.params, ...params } });
    dispatch({ type: FETCH_VRCS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VRCS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchVRCById = (id) => async (dispatch) => {
  dispatch({ type: FETCH_VRC_BY_ID_REQUEST });
  try {
    const response = await axios.get(`/vrc/${id}`, buildVRCAuthConfig(null));
    dispatch({ type: FETCH_VRC_BY_ID_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VRC_BY_ID_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const updateVRC = (id, formData) => async (dispatch) => {
  dispatch({ type: UPDATE_VRC_REQUEST });
  try {
    // NO setear Content-Type manualmente: axios/browser lo arman con el boundary correcto
    const response = await axios.put(`/vrc/${id}`, formData, buildVRCAuthConfig(formData));
    dispatch({ type: UPDATE_VRC_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_VRC_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const deleteVRC = (id) => async (dispatch) => {
  dispatch({ type: DELETE_VRC_REQUEST });
  try {
    await axios.delete(`/vrc/${id}`, buildVRCAuthConfig(null));
    dispatch({ type: DELETE_VRC_SUCCESS, payload: id });
    return true;
  } catch (error) {
    dispatch({ type: DELETE_VRC_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchVRCVersions = (id) => async (dispatch) => {
  dispatch({ type: FETCH_VRC_VERSIONS_REQUEST });
  try {
    const response = await axios.get(`/vrc/${id}/versiones`, buildVRCAuthConfig(null));
    dispatch({ type: FETCH_VRC_VERSIONS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VRC_VERSIONS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const revertVRCVersion = (vrcId, versionId) => async (dispatch) => {
  dispatch({ type: REVERT_VRC_VERSION_REQUEST });
  try {
    const response = await axios.post(`/vrc/${vrcId}/revertir/${versionId}`, null, buildVRCAuthConfig(null));
    dispatch({ type: REVERT_VRC_VERSION_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: REVERT_VRC_VERSION_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const clearVRCDetail = () => ({ type: CLEAR_VRC_DETAIL });

export const fetchVRCByCode = (vrcCode) => async (dispatch) => {
  dispatch({ type: FETCH_VRC_BY_CODE_REQUEST });
  try {
    const response = await axios.get(`/vrc/code/${vrcCode}`, buildVRCAuthConfig(null));
    dispatch({ type: FETCH_VRC_BY_CODE_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VRC_BY_CODE_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const duplicateVRC = (id) => async (dispatch) => {
  dispatch({ type: DUPLICATE_VRC_REQUEST });
  try {
    const response = await axios.post(`/vrc/${id}/duplicar`, null, buildVRCAuthConfig(null));
    dispatch({ type: DUPLICATE_VRC_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: DUPLICATE_VRC_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

export const fetchVRCStatsByAgent = (sellerId) => async (dispatch) => {
  dispatch({ type: FETCH_VRC_STATS_REQUEST });
  try {
    const response = await axios.get(`/vrc/stats/agente/${sellerId}`, buildVRCAuthConfig(null));
    dispatch({ type: FETCH_VRC_STATS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_VRC_STATS_FAIL, payload: error.response?.data?.message || error.message });
    throw error;
  }
};

// ================ ADMIN RENTALS (Solo Administración) ================
// Sistema paralelo a /rentals/admin/*. Maneja contratos donde la inmobiliaria
// solo administra el cobro sin haber originado la operación. NO impacta producción.

const adminRentalErrorPayload = (error) => {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    'Error desconocido';
  // Log centralizado: cubre todos los catch de admin-rentals sin repetir console.error en cada acción.
  console.error('[AdminRentals] Error:', message, error?.response?.data || error);
  return message;
};

// ---- Dashboard y vistas generales ----
export const fetchAdminRentalDashboard = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_RENTAL_DASHBOARD_REQUEST });
  try {
    const params = {};
    if (filters.days != null) params.days = filters.days;
    if (filters.sellerId != null && filters.sellerId !== '') params.sellerId = filters.sellerId;
    if (filters.officeId != null && filters.officeId !== '') params.officeId = filters.officeId;
    const response = await axios.get('/admin-rentals/dashboard', { params });
    dispatch({
      type: FETCH_ADMIN_RENTAL_DASHBOARD_SUCCESS,
      payload: response.data?.data || null
    });
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_RENTAL_DASHBOARD_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchActiveAdminRentals = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVE_ADMIN_RENTALS_REQUEST });
  try {
    const params = {};
    if (filters.status) params.status = filters.status;
    if (filters.sellerId != null && filters.sellerId !== '') params.sellerId = filters.sellerId;
    if (filters.officeId != null && filters.officeId !== '') params.officeId = filters.officeId;
    if (filters.page != null) params.page = filters.page;
    if (filters.limit != null) params.limit = filters.limit;
    const response = await axios.get('/admin-rentals/active', { params });
    const body = response.data || {};
    dispatch({
      type: FETCH_ACTIVE_ADMIN_RENTALS_SUCCESS,
      payload: {
        data: body?.data || [],
        meta: buildActiveRentalsMeta(body),
      },
    });
    return body;
  } catch (error) {
    dispatch({ type: FETCH_ACTIVE_ADMIN_RENTALS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchAdminRentalList = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_RENTAL_LIST_REQUEST });
  try {
    const params = {};
    if (filters.status) params.status = filters.status;
    if (filters.sellerId != null && filters.sellerId !== '') params.sellerId = filters.sellerId;
    if (filters.officeId != null && filters.officeId !== '') params.officeId = filters.officeId;
    const response = await axios.get('/admin-rentals', { params });
    dispatch({
      type: FETCH_ADMIN_RENTAL_LIST_SUCCESS,
      payload: response.data?.data || []
    });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_RENTAL_LIST_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchAdminRentalDetail = (adminRentalId) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_RENTAL_DETAIL_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/${adminRentalId}`);
    dispatch({
      type: FETCH_ADMIN_RENTAL_DETAIL_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_RENTAL_DETAIL_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchExpiringAdminRentals = (days = 30) => async (dispatch) => {
  dispatch({ type: FETCH_EXPIRING_ADMIN_RENTALS_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/expiring?days=${days}`);
    dispatch({
      type: FETCH_EXPIRING_ADMIN_RENTALS_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({ type: FETCH_EXPIRING_ADMIN_RENTALS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchOverdueAdminPayments = () => async (dispatch) => {
  dispatch({ type: FETCH_OVERDUE_ADMIN_PAYMENTS_REQUEST });
  try {
    const response = await axios.get('/admin-rentals/overdue/payments');
    dispatch({
      type: FETCH_OVERDUE_ADMIN_PAYMENTS_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({ type: FETCH_OVERDUE_ADMIN_PAYMENTS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchAdminContractSummary = (adminRentalId) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_CONTRACT_SUMMARY_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/${adminRentalId}/contract-summary`);
    dispatch({
      type: FETCH_ADMIN_CONTRACT_SUMMARY_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_CONTRACT_SUMMARY_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

// ---- CRUD contrato ----
export const createAdminRental = (rentalData) => async (dispatch) => {
  dispatch({ type: CREATE_ADMIN_RENTAL_REQUEST });
  try {
    const response = await axios.post('/admin-rentals', rentalData);
    dispatch({
      type: CREATE_ADMIN_RENTAL_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_ADMIN_RENTAL_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const updateAdminRental = (adminRentalId, partial) => async (dispatch) => {
  dispatch({ type: UPDATE_ADMIN_RENTAL_REQUEST });
  try {
    const response = await axios.put(`/admin-rentals/${adminRentalId}`, partial);
    dispatch({
      type: UPDATE_ADMIN_RENTAL_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_ADMIN_RENTAL_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const deleteAdminRental = (adminRentalId) => async (dispatch) => {
  dispatch({ type: DELETE_ADMIN_RENTAL_REQUEST });
  try {
    const response = await axios.delete(`/admin-rentals/${adminRentalId}`);
    dispatch({
      type: DELETE_ADMIN_RENTAL_SUCCESS,
      payload: { id: adminRentalId, ...response.data }
    });
    return response.data;
  } catch (error) {
    dispatch({ type: DELETE_ADMIN_RENTAL_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const cancelAdminRental = (adminRentalId, data = {}) => async (dispatch) => {
  dispatch({ type: CANCEL_ADMIN_RENTAL_REQUEST });
  try {
    const response = await axios.put(`/admin-rentals/${adminRentalId}/cancel`, data);
    dispatch({
      type: CANCEL_ADMIN_RENTAL_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: CANCEL_ADMIN_RENTAL_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const reactivateAdminRental = (adminRentalId) => async (dispatch) => {
  dispatch({ type: REACTIVATE_ADMIN_RENTAL_REQUEST });
  try {
    const response = await axios.put(`/admin-rentals/${adminRentalId}/reactivate`);
    dispatch({
      type: REACTIVATE_ADMIN_RENTAL_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: REACTIVATE_ADMIN_RENTAL_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

// ---- Pagos / cuotas ----
export const generateAdminPaymentSchedule = (adminRentalId, regenerate = false) => async (dispatch) => {
  dispatch({ type: GENERATE_ADMIN_PAYMENT_SCHEDULE_REQUEST });
  try {
    const response = await axios.post(
      `/admin-rentals/${adminRentalId}/generate-schedule`,
      { regenerate }
    );
    dispatch({
      type: GENERATE_ADMIN_PAYMENT_SCHEDULE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({ type: GENERATE_ADMIN_PAYMENT_SCHEDULE_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const fetchAdminRentalPayments = (adminRentalId, status = null) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_RENTAL_PAYMENTS_REQUEST });
  try {
    const url = status
      ? `/admin-rentals/${adminRentalId}/payments?status=${status}`
      : `/admin-rentals/${adminRentalId}/payments`;
    const response = await axios.get(url);
    dispatch({
      type: FETCH_ADMIN_RENTAL_PAYMENTS_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_RENTAL_PAYMENTS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const registerAdminRentalPayment = (paymentId, paymentData) => async (dispatch) => {
  dispatch({ type: REGISTER_ADMIN_RENTAL_PAYMENT_REQUEST });
  try {
    const response = await axios.put(
      `/admin-rentals/payments/${paymentId}/register`,
      paymentData
    );
    dispatch({
      type: REGISTER_ADMIN_RENTAL_PAYMENT_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: REGISTER_ADMIN_RENTAL_PAYMENT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const fetchUpcomingAdminPayments = (days = 7) => async (dispatch) => {
  dispatch({ type: FETCH_UPCOMING_ADMIN_PAYMENTS_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/payments/upcoming?days=${days}`);
    dispatch({
      type: FETCH_UPCOMING_ADMIN_PAYMENTS_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({ type: FETCH_UPCOMING_ADMIN_PAYMENTS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const updateOverdueAdminPayments = () => async (dispatch) => {
  dispatch({ type: UPDATE_OVERDUE_ADMIN_PAYMENTS_REQUEST });
  try {
    const response = await axios.put('/admin-rentals/payments/update-overdue');
    dispatch({
      type: UPDATE_OVERDUE_ADMIN_PAYMENTS_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_OVERDUE_ADMIN_PAYMENTS_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

// ---- Ajustes ----
export const createAdminRentalAdjustment = (adminRentalId, adjustmentData) => async (dispatch) => {
  dispatch({ type: CREATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST });
  try {
    const response = await axios.post(
      `/admin-rentals/${adminRentalId}/adjustments`,
      adjustmentData
    );
    dispatch({
      type: CREATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_ADMIN_RENTAL_ADJUSTMENT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const simulateAdminRentalAdjustment = (adminRentalId, adjustmentData) => async (dispatch) => {
  dispatch({ type: SIMULATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST });
  try {
    const response = await axios.post(
      `/admin-rentals/${adminRentalId}/adjustments/simulate`,
      adjustmentData
    );
    dispatch({
      type: SIMULATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS,
      payload: response.data?.simulation || null
    });
    return response.data?.simulation || null;
  } catch (error) {
    dispatch({ type: SIMULATE_ADMIN_RENTAL_ADJUSTMENT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const fetchAdminAdjustmentHistory = (adminRentalId) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_ADJUSTMENT_HISTORY_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/${adminRentalId}/adjustments/history`);
    dispatch({
      type: FETCH_ADMIN_ADJUSTMENT_HISTORY_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_ADJUSTMENT_HISTORY_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const fetchUpcomingAdminAdjustments = (days = 60) => async (dispatch) => {
  dispatch({ type: FETCH_UPCOMING_ADMIN_ADJUSTMENTS_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/adjustments/upcoming?days=${days}`);
    dispatch({
      type: FETCH_UPCOMING_ADMIN_ADJUSTMENTS_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({ type: FETCH_UPCOMING_ADMIN_ADJUSTMENTS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const notifyAdminAdjustment = (adjustmentId) => async (dispatch) => {
  dispatch({ type: NOTIFY_ADMIN_ADJUSTMENT_REQUEST });
  try {
    const response = await axios.put(`/admin-rentals/adjustments/${adjustmentId}/notify`);
    dispatch({
      type: NOTIFY_ADMIN_ADJUSTMENT_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: NOTIFY_ADMIN_ADJUSTMENT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

// ---- Inquilinos ----
export const createAdminRentalTenant = (adminRentalId, tenantData) => async (dispatch) => {
  dispatch({ type: CREATE_ADMIN_RENTAL_TENANT_REQUEST });
  try {
    const response = await axios.post(
      `/admin-rentals/${adminRentalId}/tenants`,
      tenantData
    );
    dispatch({
      type: CREATE_ADMIN_RENTAL_TENANT_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_ADMIN_RENTAL_TENANT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const fetchAdminRentalTenants = (adminRentalId) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_RENTAL_TENANTS_REQUEST });
  try {
    const response = await axios.get(`/admin-rentals/${adminRentalId}/tenants`);
    dispatch({
      type: FETCH_ADMIN_RENTAL_TENANTS_SUCCESS,
      payload: response.data?.data || []
    });
  } catch (error) {
    dispatch({ type: FETCH_ADMIN_RENTAL_TENANTS_FAIL, payload: adminRentalErrorPayload(error) });
  }
};

export const updateAdminRentalTenant = (tenantId, tenantData) => async (dispatch) => {
  dispatch({ type: UPDATE_ADMIN_RENTAL_TENANT_REQUEST });
  try {
    const response = await axios.put(`/admin-rentals/tenants/${tenantId}`, tenantData);
    dispatch({
      type: UPDATE_ADMIN_RENTAL_TENANT_SUCCESS,
      payload: response.data?.data || null
    });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_ADMIN_RENTAL_TENANT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const deleteAdminRentalTenant = (tenantId) => async (dispatch) => {
  dispatch({ type: DELETE_ADMIN_RENTAL_TENANT_REQUEST });
  try {
    const response = await axios.delete(`/admin-rentals/tenants/${tenantId}`);
    dispatch({
      type: DELETE_ADMIN_RENTAL_TENANT_SUCCESS,
      payload: { tenantId, ...response.data }
    });
    return response.data;
  } catch (error) {
    dispatch({ type: DELETE_ADMIN_RENTAL_TENANT_FAIL, payload: adminRentalErrorPayload(error) });
    throw error;
  }
};

export const clearAdminRentalState = () => ({ type: CLEAR_ADMIN_RENTAL_STATE });

// ================================================================
// AUDITORÍA, RENOVACIONES Y COBERTURA (regular + admin)
// El tipo ('admin' | 'regular') determina el prefijo de la URL.
// ================================================================

// Prefijo base según el tipo de alquiler.
const rentalBasePath = (type) => (type === 'admin' ? '/admin-rentals' : '/rentals/admin');

// Bitácora de auditoría de un contrato.
export const fetchRentalAuditLog = (rentalId, { action, limit = 100, offset = 0 } = {}, type = 'regular') => async (dispatch) => {
  dispatch({ type: FETCH_RENTAL_AUDIT_LOG_REQUEST, meta: { rentalType: type } });
  try {
    const params = { limit, offset };
    if (action) params.action = action;
    const { data } = await axios.get(`${rentalBasePath(type)}/${rentalId}/audit-log`, { params });
    dispatch({
      type: FETCH_RENTAL_AUDIT_LOG_SUCCESS,
      payload: { data: data?.data || [], pagination: data?.pagination || null },
      meta: { rentalType: type },
    });
    return data;
  } catch (error) {
    dispatch({ type: FETCH_RENTAL_AUDIT_LOG_FAIL, payload: adminRentalErrorPayload(error), meta: { rentalType: type } });
    throw error;
  }
};

// Historial global de operaciones realizadas.
export const fetchOperationsHistory = (filters = {}, type = 'regular') => async (dispatch) => {
  dispatch({ type: FETCH_OPERATIONS_HISTORY_REQUEST, meta: { rentalType: type } });
  try {
    const params = {};
    ['action', 'from', 'to', 'performedBy', 'limit', 'offset'].forEach((k) => {
      if (filters[k] !== undefined && filters[k] !== null && filters[k] !== '') params[k] = filters[k];
    });
    // La clave del id de contrato difiere entre sistemas.
    if (filters.rentalId) params[type === 'admin' ? 'adminRentalId' : 'rentalId'] = filters.rentalId;
    const { data } = await axios.get(`${rentalBasePath(type)}/reports/operations-history`, { params });
    dispatch({
      type: FETCH_OPERATIONS_HISTORY_SUCCESS,
      payload: {
        data: data?.data || [],
        summary: data?.summary || { byAction: [] },
        pagination: data?.pagination || null,
        filters: data?.filters || {},
      },
      meta: { rentalType: type },
    });
    return data;
  } catch (error) {
    dispatch({ type: FETCH_OPERATIONS_HISTORY_FAIL, payload: adminRentalErrorPayload(error), meta: { rentalType: type } });
    throw error;
  }
};

// Cobertura de contratos (firmados/documentados vs sin contrato).
export const fetchContractsCoverage = (type = 'regular') => async (dispatch) => {
  dispatch({ type: FETCH_CONTRACTS_COVERAGE_REQUEST, meta: { rentalType: type } });
  try {
    const { data } = await axios.get(`${rentalBasePath(type)}/reports/contracts-coverage`);
    dispatch({
      type: FETCH_CONTRACTS_COVERAGE_SUCCESS,
      payload: data?.data || null,
      meta: { rentalType: type },
    });
    return data;
  } catch (error) {
    dispatch({ type: FETCH_CONTRACTS_COVERAGE_FAIL, payload: adminRentalErrorPayload(error), meta: { rentalType: type } });
    throw error;
  }
};

// Reporte de cadenas de renovación por propiedad.
export const fetchRenewalsReport = (type = 'regular') => async (dispatch) => {
  dispatch({ type: FETCH_RENEWALS_REPORT_REQUEST, meta: { rentalType: type } });
  try {
    const { data } = await axios.get(`${rentalBasePath(type)}/reports/renewals`);
    dispatch({
      type: FETCH_RENEWALS_REPORT_SUCCESS,
      payload: data?.data || null,
      meta: { rentalType: type },
    });
    return data;
  } catch (error) {
    dispatch({ type: FETCH_RENEWALS_REPORT_FAIL, payload: adminRentalErrorPayload(error), meta: { rentalType: type } });
    throw error;
  }
};

// Renovación de contrato: cierra el anterior y crea uno nuevo con genealogía.
export const renewRental = (rentalId, payload = {}, type = 'regular') => async (dispatch) => {
  dispatch({ type: RENEW_RENTAL_REQUEST, meta: { rentalType: type } });
  try {
    const { data } = await axios.post(
      `${rentalBasePath(type)}/${rentalId}/renew`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
    dispatch({
      type: RENEW_RENTAL_SUCCESS,
      payload: data?.data || data,
      meta: { rentalType: type },
    });
    return data?.data || data;
  } catch (error) {
    dispatch({
      type: RENEW_RENTAL_FAIL,
      payload: {
        message: adminRentalErrorPayload(error),
        errorCode: error?.response?.data?.errorCode || null,
        status: error?.response?.status || null,
      },
      meta: { rentalType: type },
    });
    throw error;
  }
};

// ================================================================
// BLOG / FEED
// El contenido se sirve por endpoints controlados (anti-descarga).
// Las cargas usan multipart/form-data (archivos + campos de texto).
// ================================================================

// Listar feed con filtros y paginación. GET /blog
export const fetchBlogPosts = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_BLOG_POSTS_REQUEST });
  try {
    const params = {};
    [
      'category', 'officeId', 'franquiciaId', 'tag', 'dateFrom', 'dateTo',
      'search', 'featured', 'status', 'page', 'limit', 'sort',
    ].forEach((k) => {
      if (filters[k] !== undefined && filters[k] !== null && filters[k] !== '') {
        params[k] = filters[k];
      }
    });
    const { data } = await axios.get('/blog', { params });
    dispatch({ type: FETCH_BLOG_POSTS_SUCCESS, payload: data?.data || { items: [] } });
    return data?.data;
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: FETCH_BLOG_POSTS_FAIL, payload: normalized.userMessage });
    return { items: [], error: normalized.userMessage };
  }
};

// Opciones de filtros para poblar los selects. GET /blog/filters
export const fetchBlogFilters = () => async (dispatch) => {
  dispatch({ type: FETCH_BLOG_FILTERS_REQUEST });
  try {
    const { data } = await axios.get('/blog/filters');
    dispatch({ type: FETCH_BLOG_FILTERS_SUCCESS, payload: data?.data || null });
    return data?.data;
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: FETCH_BLOG_FILTERS_FAIL, payload: normalized.userMessage });
  }
};

// Detalle por id. GET /blog/:id (incrementa vistas en el backend)
export const fetchBlogPostById = (id) => async (dispatch) => {
  dispatch({ type: FETCH_BLOG_DETAIL_REQUEST });
  try {
    const { data } = await axios.get(`/blog/${id}`);
    dispatch({ type: FETCH_BLOG_DETAIL_SUCCESS, payload: data?.data || null });
    return data?.data;
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: FETCH_BLOG_DETAIL_FAIL, payload: normalized.userMessage });
    return null;
  }
};

// Detalle por slug. GET /blog/slug/:slug
export const fetchBlogPostBySlug = (slug) => async (dispatch) => {
  dispatch({ type: FETCH_BLOG_DETAIL_REQUEST });
  try {
    const { data } = await axios.get(`/blog/slug/${slug}`);
    dispatch({ type: FETCH_BLOG_DETAIL_SUCCESS, payload: data?.data || null });
    return data?.data;
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: FETCH_BLOG_DETAIL_FAIL, payload: normalized.userMessage });
    return null;
  }
};

// Crear publicación. POST /blog (multipart/form-data)
export const createBlogPost = (formData, options = {}) => async (dispatch) => {
  const { onUploadProgress, signal } = options;
  dispatch({ type: CREATE_BLOG_POST_REQUEST });
  try {
    const config = {
      timeout: BLOG_LIMITS.REQUEST_TIMEOUT_MS,
      signal,
      onUploadProgress,
    };
    const { data } = await axios.post('/blog', formData, config);
    dispatch({ type: CREATE_BLOG_POST_SUCCESS, payload: data?.data || null });
    return { success: true, data: data?.data, message: data?.message };
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: CREATE_BLOG_POST_FAIL, payload: normalized.userMessage });
    return {
      success: false,
      message: normalized.userMessage,
      type: normalized.type,
      status: normalized.status,
      fieldErrors: normalized.fieldErrors,
      errors: normalized.errors,
      retriable: normalized.retriable,
    };
  }
};

// Editar publicación. PUT /blog/:id (multipart/form-data)
export const updateBlogPost = (id, formData, options = {}) => async (dispatch) => {
  const { onUploadProgress, signal } = options;
  dispatch({ type: UPDATE_BLOG_POST_REQUEST });
  try {
    const config = {
      timeout: BLOG_LIMITS.REQUEST_TIMEOUT_MS,
      signal,
      onUploadProgress,
    };
    const { data } = await axios.put(`/blog/${id}`, formData, config);
    dispatch({ type: UPDATE_BLOG_POST_SUCCESS, payload: data?.data || null });
    return { success: true, data: data?.data, message: data?.message };
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: UPDATE_BLOG_POST_FAIL, payload: normalized.userMessage });
    return {
      success: false,
      message: normalized.userMessage,
      type: normalized.type,
      status: normalized.status,
      fieldErrors: normalized.fieldErrors,
      errors: normalized.errors,
      retriable: normalized.retriable,
    };
  }
};

// Eliminar publicación. DELETE /blog/:id
export const deleteBlogPost = (id) => async (dispatch) => {
  dispatch({ type: DELETE_BLOG_POST_REQUEST });
  try {
    const { data } = await axios.delete(`/blog/${id}`);
    dispatch({ type: DELETE_BLOG_POST_SUCCESS, payload: { id, ...data } });
    return { success: true, message: data?.message };
  } catch (error) {
    const normalized = parseApiError(error);
    dispatch({ type: DELETE_BLOG_POST_FAIL, payload: normalized.userMessage });
    return { success: false, message: normalized.userMessage };
  }
};

export const clearBlogDetail = () => ({ type: CLEAR_BLOG_DETAIL });

// Actualiza el estado de firma / documentos de un contrato existente.
// Reutiliza los endpoints de update: PUT /rental/:id (regular) y
// PUT /admin-rentals/:id (admin). El payload puede incluir:
// { hasSignedContract, contractSignedDate, documentRent }.
export const updateContractSignature = (rentalId, payload = {}, type = 'regular') => async (dispatch) => {
  const isAdmin = type === 'admin';
  dispatch({ type: isAdmin ? UPDATE_ADMIN_RENTAL_REQUEST : UPDATE_RENTAL_REQUEST });
  try {
    const url = isAdmin ? `/admin-rentals/${rentalId}` : `/rental/${rentalId}`;
    const { data } = await axios.put(url, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    dispatch({
      type: isAdmin ? UPDATE_ADMIN_RENTAL_SUCCESS : UPDATE_RENTAL_SUCCESS,
      payload: data?.data || data,
    });
    return data?.data || data;
  } catch (error) {
    dispatch({
      type: isAdmin ? UPDATE_ADMIN_RENTAL_FAIL : UPDATE_RENTAL_FAILURE,
      payload: isAdmin
        ? adminRentalErrorPayload(error)
        : error?.response?.data?.message || error.message,
    });
    throw error;
  }
};

/**
 * Sube documentos del contrato (documentRent) usando multer (multipart/form-data).
 * Regular  -> PUT /rental/:id/documents
 * Admin    -> PUT /admin-rentals/:id/documents
 *
 * @param {string} rentalId  Id del contrato.
 * @param {File[]} files     Archivos nuevos a subir (máx 10, 30MB c/u).
 * @param {string[]} existingUrls  URLs de documentos ya subidos que se quieren conservar.
 * @param {'regular'|'admin'} type
 * @param {{ performedBy?: string, performedByName?: string }} meta
 * @returns contrato actualizado (incluye documentRent con las URLs finales).
 */
export const uploadContractDocuments = (
  rentalId,
  files = [],
  existingUrls = [],
  type = 'regular',
  meta = {}
) => async (dispatch) => {
  const isAdmin = type === 'admin';
  dispatch({ type: isAdmin ? UPDATE_ADMIN_RENTAL_REQUEST : UPDATE_RENTAL_REQUEST });
  try {
    const url = isAdmin
      ? `/admin-rentals/${rentalId}/documents`
      : `/rental/${rentalId}/documents`;

    const formData = new FormData();
    (files || []).forEach((file) => formData.append('documentRent', file));
    if (Array.isArray(existingUrls) && existingUrls.length > 0) {
      formData.append('existingDocumentRent', JSON.stringify(existingUrls));
    }
    if (meta.performedBy) formData.append('performedBy', meta.performedBy);
    if (meta.performedByName) formData.append('performedByName', meta.performedByName);

    // No seteamos Content-Type: el browser agrega el boundary de multipart.
    const { data } = await axios.put(url, formData);
    dispatch({
      type: isAdmin ? UPDATE_ADMIN_RENTAL_SUCCESS : UPDATE_RENTAL_SUCCESS,
      payload: data?.data || data,
    });
    return data?.data || data;
  } catch (error) {
    dispatch({
      type: isAdmin ? UPDATE_ADMIN_RENTAL_FAIL : UPDATE_RENTAL_FAILURE,
      payload: isAdmin
        ? adminRentalErrorPayload(error)
        : error?.response?.data?.message || error.message,
    });
    throw error;
  }
};